import React, {useEffect, useRef, useState} from 'react';
import { observer } from 'mobx-react'
import './index.css';
import lang from "../../lang";
import logoeditor from '../../assets/logoeditor.svg';
import GlobalState, {changeSingleCompain, changeStrategyId} from "../../stores/GlobalState";
import { SSE } from 'sse.js';
import Domen from "../../stores/Domen";
import Lottie from 'lottie-react';
import Load from '../../assets/load.json';
import { useNavigate } from 'react-router-dom';
import MarkdownRenderer from "../MarkdownRenderer/MarkdownRenderer";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';
import { restrictToVerticalAxis/*, restrictToParentElement*/ } from '@dnd-kit/modifiers';
import {useDndMonitor} from '@dnd-kit/core';
import {CSS} from '@dnd-kit/utilities';
import Loading from '../common/loading';
import LoadingFail from '../common/loading_fail';


const formatDate = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');      // 01..31
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 00..11 → +1
    const year = date.getFullYear();                          // 2025

    return `${day}.${month}.${year}`;
};

const SortableItem = React.memo(function SortableItem({ id, title, reg1, reg2, reg3, description, open, new_st, value, company, onChange, onClose, onDelete, getDataStrategy, getDataWorkspace, items, itemAll }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id });
    const [textloading, setTextloading] = useState("Loading...");

    const fixedTransform =
    transform
      ? { ...transform, scaleX: 1, scaleY: 1 }
      : undefined;    

    const style = {
        transform: CSS.Transform.toString(fixedTransform),
        transition,
        willChange: 'transform',
    };
    console.log(itemAll);
    const [localTitle, setLocalTitle] = React.useState(value.title);
    const [localDescription, setLocalDescription] = React.useState(value.description);
    const [localOpen, setLocalUpdate] = React.useState(value.open);
    const [localNew_st, setLocalNew_st] = React.useState(value.new_st);
    const [load, setLoad] = useState(false);
    const [tooltipe, setTooltipe] = useState(false);
    const [long, setLong] = useState(!!company?.length);
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)

    const [popupDelete, setPopupDelete] = useState(false);
    const [idDelete, setIdDelete] = useState(false);
    const [idError, setIdError] = useState(false);
    const [ower, setOwer] = useState(false);




    useDndMonitor({
        onDragStart: ({active}) => {
      
            setLong(false)
            setPopupDelete(false);
            setTooltipe(false)
        },
        onDragMove: ({active, delta, over}) => {
       
            setLong(false)
        
        },
        onDragEnd: ({active, over}) => {
       
            setLong(false);
            setPopupDelete(false);
            setTooltipe(false)
        
        },
        onDragCancel: ({active}) => {
        
            setLong(false)
        
        }
    });
  
 
    const navigate = useNavigate();
    
    React.useEffect(() => {
        setLocalTitle(value.title);
        setLocalDescription(value.description);
        setLocalUpdate(value.open);
    }, [id]);
    


    const handleTitleChange = (e) => {
        const newVal = e.target.value;
        setLocalTitle(newVal);
        onChange(id, "title", newVal);
        setIdError(false)
    };

    const handleDescriptionChange = (e) => {
        const newVal = e.target.value;
        setLocalDescription(newVal);
        onChange(id, "description", newVal);
    };

    const handleUpdateChange = async(e) => {
        setLoad(true)
        var newlocal = localTitle.trim();
        var newdesk = localDescription.trim();
        setLocalTitle(newlocal);
        setLocalDescription(newdesk);
        if(new_st)
        {
            var token = localStorage.getItem("token");
            var attr = {
                name: newlocal,
                description: newdesk
            };
            localStorage.setItem("countactivetime", Date.now());
            const response = await fetch(Domen.url + `strategy/goals`, {
                method: 'POST',
                headers: {
                    'Authorization': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(attr),
            })
            if(response.status=="200"||response.status=="202")
            {
                const data = await response.json();
            
                console.log(data + "test strategy/goals/ POST")
                const newVal = false;
                setLocalUpdate(newVal);
                setLocalNew_st(newVal)
                onChange(id, "open", newVal);
                onChange(id, "new_st", newVal);
                setLoad(false)
                getDataStrategy();
            }
            else
            {
                setLoad(false);
                setIdError(true);

            }
        }
        else
        {
            var token = localStorage.getItem("token");
            var attr = {
                name: newlocal,
                description: newdesk
            };
            localStorage.setItem("countactivetime", Date.now());
            const response = await fetch(Domen.url + `strategy/goals/`+id, {
                method: 'PUT',
                headers: {
                    'Authorization': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(attr),
            })
            if(response.status=="200"||response.status=="202")
            {
                const data = await response.json();
            
                console.log(data + "test strategy/goals/ POST")
                const newVal = false;
                setLocalUpdate(newVal);
                setLocalNew_st(newVal)
                onChange(id, "open", newVal);
                onChange(id, "new_st", newVal);
                setLoad(false);
                getDataStrategy();
        
            }
            else
            {
                setLoad(false);
                setIdError(true);
            }
        }
    };
    
    const handleUpdateChangeTrue = (e) => {
        const newVal = true;
        setLocalUpdate(newVal);
        onChange(id, "open", newVal);
        setTooltipe(false)
    };

    const onClose0 = (id)=>{
        onClose(id);
        setLocalUpdate(false);
    }

    const setPopupDelete0 = (id)=>{
        setPopupDelete(true)
        setIdDelete(id)
    }
    const setPopupDelete1 = ()=>{
        setPopupDelete(false)
        setTooltipe(false)
    }


    const onDelete0 = async()=>{
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `strategy/goals/`+idDelete+`?force=true`, {
            method: 'DELETE',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status>199&&response.status<399)
        {
            //const data = await response.json();

            onDelete(id)
            setLocalUpdate(false);
            setTooltipe(false); 
            setPopupDelete(false);
        }
        else
        {
            alert("Something went wrong, request status:" + response.status)
        }

        
    }

    function getNextCampaignName(baseName) {
        const matching = items.map(c => c.name);

        // Якщо немає базової назви без цифри
        if (!matching.includes(baseName)) {
            return baseName; // створюємо без номера
        }

        // Знаходимо всі варіанти з цифрами
        const maxNum = matching.reduce((max, name) => {
            if (name.startsWith(baseName + "_")) {
            const num = parseInt(name.split("_").pop(), 10);
            if (!isNaN(num) && num > max) {
                return num;
            }
            }
            return max;
        }, 0);

        return `${baseName}_${maxNum + 1}`;
    }

    const addCompain = async(a) =>
    {

        const newName = getNextCampaignName("new_campaign");
        console.log(newName);
        var token = localStorage.getItem("token");
        var param = {
            "name": newName,
            "description": ""
        };
        const response = await fetch(Domen.url + `strategy/goals/`+a+`/campaigns`, {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(param),
        })
        
        if(response.status=="200")
        {
            const data = await response.json();
            navigate(`/${title}/compain/${data.name}`); 
        } 
        changeStrategyId(id)
    }

    const openCompain = (id0, comp, title)=>{
        changeSingleCompain(comp);   
        navigate(`/${title}/compain/${id0}`);
        console.log(id)
        changeStrategyId(id)  
    }

    const deleteCompain = async(id_comp, id00)=>{
        setOwer(true);
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `strategy/goals/`+id+`/campaigns/`+id_comp+`?confirm=true`, {
            method: 'DELETE',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            getDataStrategy();
            getDataWorkspace();
            setOwer(false);
            toggleTip(id00);
        }  
    }


    const [openTip, setOpenTip] = useState(null);

    const toggleTip = (idx) => {
        setOpenTip((prev) => (prev === idx ? null : idx));
    };

    useEffect(() => {
        const onDocClick = () => setOpenTip(null);
        document.addEventListener("click", onDocClick);
        return () => document.removeEventListener("click", onDocClick);
    }, []);

    return (
        <>
            {
                popupDelete?
                    <div ref={setNodeRef} className='drag_strategy drag_strategy_cursor' style={style} {...attributes} >
                        <div >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.6">
                            <path d="M5 2H6.71429V3.84615H5V2ZM9.28571 2H11V3.84615H9.28571V2ZM5 5.38462H6.71429V7.23077H5V5.38462ZM9.28571 5.38462H11V7.23077H9.28571V5.38462ZM5 8.76923H6.71429V10.6154H5V8.76923ZM9.28571 8.76923H11V10.6154H9.28571V8.76923ZM5 12.1538H6.71429V14H5V12.1538ZM9.28571 12.1538H11V14H9.28571V12.1538Z" fill="#8E8E93"/>
                            </g>
                            </svg>
                        </div>
                        <div className='drag_arrow_line delete_line_open'>
                            <div className='line_form_strategy delete_line_st_open'>
                                <div className='sub_str_title'>
                                    {langv?.strategy?.field_delete?.title_1}<br/>  {langv?.strategy?.field_delete?.title_2} <span>{localTitle}</span> {langv?.strategy?.field_delete?.title_3} <span>{company?.length || "0"}</span> {langv?.strategy?.field_delete?.title_4} 
                                </div>
                                <div className='sub_str_del'>
                                    {langv?.strategy?.field_delete?.subtitle}
                                </div>
                            </div>
                            <div className='line_form_strategy delete_line_but_open'>
                                
                                <div className='apply_strategy active' onClick={()=>onDelete0()}>Yes</div>
                                   
                                <div className='close_strategy' onClick={() => setPopupDelete1(false)}>{langv?.strategy?.button_2}</div>
                            </div>
                        </div>
                    </div>
                :
                    localOpen?
                    <div ref={setNodeRef} className='drag_strategy ' style={style} {...attributes} >
                        <div >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.6">
                            <path d="M5 2H6.71429V3.84615H5V2ZM9.28571 2H11V3.84615H9.28571V2ZM5 5.38462H6.71429V7.23077H5V5.38462ZM9.28571 5.38462H11V7.23077H9.28571V5.38462ZM5 8.76923H6.71429V10.6154H5V8.76923ZM9.28571 8.76923H11V10.6154H9.28571V8.76923ZM5 12.1538H6.71429V14H5V12.1538ZM9.28571 12.1538H11V14H9.28571V12.1538Z" fill="#8E8E93"/>
                            </g>
                            </svg>
                        </div>
                        <div className='drag_arrow_line drag_arrow_line_open'>
                            {
                                load?
                                <div className='load_strategy'>
                                    <Loading text = {textloading}/>
                                </div>
                                :
                                <>
                                
                                    <div className='line_form_strategy'>
                                        
                                        {
                                            idError?
                                            <div className='error_input'>
                                            <input value={localTitle} onChange={handleTitleChange}  placeholder='Type goal name'/>
                                            <p>The name must be unique </p>
                                            </div>
                                            :
                                            <input value={localTitle} onChange={handleTitleChange} placeholder='Type goal name'/>
                                        }
                                    </div>
                                    <div className='line_form_strategy'>
                                        <textarea value={localDescription} onChange={handleDescriptionChange} placeholder='Type description'></textarea>
                                    </div>
                                    <div className='line_form_strategy'>
                                        {
                                            title.trim().length > 0!=""?
                                            <div className='apply_strategy active' onClick={handleUpdateChange}>{langv?.strategy?.button_1}</div>
                                            :
                                            <div className='apply_strategy'>{langv?.strategy?.button_1}</div>
                                        }
                                        <div className='close_strategy' onClick={() => onClose0(id)}>{langv?.strategy?.button_2}</div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                    :
                    <div ref={setNodeRef} className={tooltipe?'drag_strategy active':'drag_strategy'} style={style} {...attributes} >
                        <div className='drag_strategy_cursor' {...listeners}>
                        
                            <svg  width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.6">
                                <path d="M5 2H6.71429V3.84615H5V2ZM9.28571 2H11V3.84615H9.28571V2ZM5 5.38462H6.71429V7.23077H5V5.38462ZM9.28571 5.38462H11V7.23077H9.28571V5.38462ZM5 8.76923H6.71429V10.6154H5V8.76923ZM9.28571 8.76923H11V10.6154H9.28571V8.76923ZM5 12.1538H6.71429V14H5V12.1538ZM9.28571 12.1538H11V14H9.28571V12.1538Z" fill="#8E8E93"/>
                                </g>
                            </svg>
                                
                            
                        </div>
                        <div className='drag_arrow_line'>
                            <div className='drag_arrow_subline'>
                                <div  className='drag_arrow'>
                                    {
                                        long?
                                        <svg onClick={()=>setLong(!long)} className='menu_singl_drag' width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_4130_43779)">
                                            <path d="M11.6119 6.36534L12.3185 5.65801L8.46721 1.80534C8.4055 1.74324 8.33211 1.69395 8.25128 1.66032C8.17045 1.62669 8.08376 1.60938 7.99621 1.60938C7.90866 1.60938 7.82197 1.62669 7.74114 1.66032C7.6603 1.69395 7.58692 1.74324 7.52521 1.80534L3.67187 5.65801L4.37854 6.36468L7.99521 2.74868L11.6119 6.36534Z" fill="black"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_4130_43779">
                                            <rect width="8" height="16" fill="white" transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16 8)"/>
                                            </clipPath>
                                            </defs>
                                        </svg>

                                        :
                                        <svg onClick={()=>setLong(!long)} className='menu_singl_drag' width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_3805_23080)">
                                            <path d="M4.38812 1.63466L3.68146 2.34199L7.53279 6.19466C7.5945 6.25676 7.66789 6.30605 7.74872 6.33968C7.82955 6.37331 7.91624 6.39063 8.00379 6.39063C8.09134 6.39063 8.17803 6.37331 8.25886 6.33968C8.3397 6.30605 8.41308 6.25676 8.47479 6.19466L12.3281 2.34199L11.6215 1.63532L8.00479 5.25132L4.38812 1.63466Z" fill="black"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_3805_23080">
                                            <rect width="8" height="16" fill="white" transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0)"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                        
                                    }

                                </div>
                                <div className='drag_body'>
                                    <div className='drag_body_line'>
                                        <div className='drag_body_title'>
                                            {title}
                                        </div>
                                        <div className='drag_body_regal'>
                                            <div>
                                                <svg  width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.8" clip-path="url(#clip0_3805_61547)">
                                                    <path d="M7.8457 6.13086C9.41734 6.13086 10.6914 4.85679 10.6914 3.28516C10.6914 1.71352 9.41734 0.439453 7.8457 0.439453C6.27406 0.439453 5 1.71352 5 3.28516C5 4.85679 6.27406 6.13086 7.8457 6.13086Z" stroke="#007AFF" stroke-width="0.8"/>
                                                    <path d="M13.582 11.4661C13.582 13.234 13.582 14.6675 7.89062 14.6675C2.19922 14.6675 2.19922 13.234 2.19922 11.4661C2.19922 9.69817 4.74755 8.26465 7.89062 8.26465C11.0337 8.26465 13.582 9.69817 13.582 11.4661Z" stroke="#007AFF" stroke-width="0.8"/>
                                                    <g clip-path="url(#clip1_3805_61547)">
                                                    <path d="M14.7984 6.90039H10.5984C10.2118 6.90039 9.89844 7.21379 9.89844 7.60039V10.4004C9.89844 10.787 10.2118 11.1004 10.5984 11.1004H14.7984C15.185 11.1004 15.4984 10.787 15.4984 10.4004V7.60039C15.4984 7.21379 15.185 6.90039 14.7984 6.90039Z" fill="#F2F2F7" stroke="#007AFF" stroke-width="0.8"/>
                                                    <path d="M9.89844 7.9502L12.3855 9.19375C12.4827 9.2423 12.5898 9.26757 12.6984 9.26757C12.8071 9.26757 12.9142 9.2423 13.0113 9.19375L15.4984 7.9502" stroke="#007AFF" stroke-width="0.8"/>
                                                    </g>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_3805_61547">
                                                    <rect width="16" height="16" fill="white"/>
                                                    </clipPath>
                                                    <clipPath id="clip1_3805_61547">
                                                    <rect width="7" height="7" fill="white" transform="translate(9.19922 5.5)"/>
                                                    </clipPath>
                                                    </defs>
                                                </svg>
                                                {reg1}
                                                <span>{reg2} %</span>
                                            </div>
                                            <div>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.7388 2.26165C14.5762 2.09913 14.3833 1.97021 14.171 1.88225C13.9587 1.79429 13.7311 1.74902 13.5013 1.74902C13.2714 1.74902 13.0438 1.79429 12.8315 1.88225C12.6192 1.97021 12.4263 2.09913 12.2638 2.26165C12.1012 2.42415 11.9723 2.61708 11.8844 2.82941C11.7964 3.04174 11.7511 3.26932 11.7511 3.49915C11.7511 3.72898 11.7964 3.95656 11.8844 4.16889C11.9723 4.38122 12.1012 4.57414 12.2638 4.73665C12.3247 4.79813 12.3903 4.85476 12.46 4.90602L10.6019 8.35665C10.3285 8.25718 10.0348 8.2272 9.74696 8.26942C9.45917 8.31164 9.18638 8.42473 8.95313 8.59853L7.40188 7.04727C7.66682 6.69296 7.78774 6.25145 7.7403 5.81158C7.69285 5.37172 7.48056 4.96614 7.14615 4.67648C6.81173 4.38682 6.38002 4.23458 5.93789 4.25038C5.49575 4.26618 5.07601 4.44886 4.76313 4.76165C4.58512 4.9396 4.44759 5.15385 4.35992 5.38979C4.27226 5.62573 4.23652 5.87781 4.25515 6.12882C4.27378 6.37983 4.34633 6.62387 4.46787 6.84428C4.5894 7.0647 4.75705 7.2563 4.95938 7.40602L3.10063 10.8573C2.78743 10.7427 2.44803 10.72 2.12238 10.7919C1.79673 10.8638 1.4984 11.0272 1.2625 11.2629C1.01778 11.5076 0.851123 11.8195 0.783613 12.1589C0.716104 12.4984 0.75077 12.8503 0.883229 13.17C1.01569 13.4898 1.23999 13.7631 1.52777 13.9554C1.81555 14.1476 2.15389 14.2503 2.5 14.2503C2.84611 14.2503 3.18445 14.1476 3.47223 13.9554C3.76001 13.7631 3.98431 13.4898 4.11677 13.17C4.24923 12.8503 4.2839 12.4984 4.21639 12.1589C4.14888 11.8195 3.98222 11.5076 3.7375 11.2629C3.67621 11.2018 3.61063 11.1452 3.54125 11.0935L5.39938 7.6429C5.67264 7.74282 5.96651 7.77304 6.25439 7.73081C6.54227 7.68857 6.81508 7.57523 7.04813 7.40102L8.59938 8.95228C8.39197 9.22978 8.27159 9.56261 8.2535 9.90858C8.23542 10.2546 8.32043 10.5981 8.49777 10.8957C8.67512 11.1934 8.93681 11.4317 9.2497 11.5804C9.56259 11.7292 9.91259 11.7817 10.2554 11.7314C10.5981 11.681 10.9183 11.5301 11.1752 11.2977C11.4321 11.0652 11.6142 10.7618 11.6985 10.4257C11.7828 10.0897 11.7655 9.73621 11.6487 9.41003C11.5319 9.08386 11.3209 8.79969 11.0425 8.59352L12.9006 5.14227C13.2748 5.27883 13.6844 5.28364 14.0618 5.15589C14.4391 5.02814 14.7615 4.77548 14.9758 4.43967C15.1901 4.10386 15.2834 3.70499 15.2403 3.30898C15.1972 2.91296 15.0203 2.5435 14.7388 2.26165ZM3.38375 13.3867C3.20895 13.5615 2.98622 13.6806 2.74374 13.7289C2.50125 13.7771 2.2499 13.7524 2.02147 13.6578C1.79304 13.5632 1.59779 13.403 1.46042 13.1974C1.32305 12.9918 1.24973 12.7501 1.24973 12.5029C1.24973 12.2557 1.32305 12.014 1.46042 11.8084C1.59779 11.6028 1.79304 11.4426 2.02147 11.348C2.2499 11.2534 2.50125 11.2287 2.74374 11.2769C2.98622 11.3252 3.20895 11.4443 3.38375 11.6192C3.61733 11.8535 3.74849 12.1708 3.74849 12.5016C3.74849 12.8325 3.61733 13.1498 3.38375 13.3841V13.3867ZM5.11625 6.88665C4.94149 6.71181 4.82248 6.48908 4.77429 6.24662C4.7261 6.00416 4.75089 5.75285 4.84551 5.52447C4.94014 5.2961 5.10035 5.1009 5.3059 4.96357C5.51145 4.82624 5.75311 4.75295 6.00031 4.75295C6.24752 4.75295 6.48917 4.82624 6.69472 4.96357C6.90027 5.1009 7.06049 5.2961 7.15511 5.52447C7.24974 5.75285 7.27452 6.00416 7.22633 6.24662C7.17814 6.48908 7.05914 6.71181 6.88438 6.88665C6.76809 7.00257 6.63011 7.09445 6.47831 7.15703C6.3265 7.21961 6.16386 7.25167 5.99967 7.25138C5.83547 7.25109 5.67294 7.21846 5.52136 7.15534C5.36978 7.09222 5.23212 6.99986 5.11625 6.88352V6.88665ZM10.885 10.8867C10.7102 11.0614 10.4874 11.1804 10.245 11.2286C10.0025 11.2768 9.7512 11.252 9.52283 11.1574C9.29445 11.0628 9.09925 10.9025 8.96192 10.697C8.82459 10.4914 8.7513 10.2498 8.7513 10.0026C8.7513 9.75538 8.82459 9.51373 8.96192 9.30818C9.09925 9.10263 9.29445 8.94241 9.52283 8.84779C9.7512 8.75316 10.0025 8.72838 10.245 8.77657C10.4874 8.82476 10.7102 8.94376 10.885 9.11852C11.1188 9.35286 11.25 9.67034 11.25 10.0013C11.25 10.3323 11.1188 10.6498 10.885 10.8841V10.8867ZM14.385 4.38665C14.2102 4.56141 13.9874 4.68042 13.745 4.72861C13.5025 4.7768 13.2512 4.75201 13.0228 4.65739C12.7944 4.56276 12.5993 4.40255 12.4619 4.197C12.3246 3.99145 12.2513 3.74979 12.2513 3.50259C12.2513 3.25538 12.3246 3.01373 12.4619 2.80818C12.5993 2.60263 12.7944 2.44241 13.0228 2.34779C13.2512 2.25316 13.5025 2.22838 13.745 2.27657C13.9874 2.32476 14.2102 2.44376 14.385 2.61852C14.6186 2.85283 14.7497 3.17018 14.7497 3.50102C14.7497 3.83187 14.6186 4.14922 14.385 4.38352V4.38665Z" fill="#007AFF" stroke="#007AFF" stroke-width="0.3"/>
                                                </svg>
                                                {reg3}
                                            </div>
                                            <div className='menu_singl_drag' onBlur={()=>setTooltipe(false)} tabIndex={id}>
                                                
                                                <svg className='tooltipe_icon_open' onClick={()=>setTooltipe(true)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect y="24" width="24" height="24" rx="4" transform="rotate(-90 0 24)" fill="#EFEFF0"/>
                                                    <path d="M5.41406 13.3125C5.76216 13.3125 6.096 13.1742 6.34214 12.9281C6.58828 12.6819 6.72656 12.3481 6.72656 12C6.72656 11.6519 6.58828 11.3181 6.34214 11.0719C6.096 10.8258 5.76216 10.6875 5.41406 10.6875C5.06597 10.6875 4.73213 10.8258 4.48598 11.0719C4.23984 11.3181 4.10156 11.6519 4.10156 12C4.10156 12.3481 4.23984 12.6819 4.48598 12.9281C4.73213 13.1742 5.06597 13.3125 5.41406 13.3125ZM11.9766 13.3125C12.3247 13.3125 12.6585 13.1742 12.9046 12.9281C13.1508 12.6819 13.2891 12.3481 13.2891 12C13.2891 11.6519 13.1508 11.3181 12.9046 11.0719C12.6585 10.8258 12.3247 10.6875 11.9766 10.6875C11.6285 10.6875 11.2946 10.8258 11.0485 11.0719C10.8023 11.3181 10.6641 11.6519 10.6641 12C10.6641 12.3481 10.8023 12.6819 11.0485 12.9281C11.2946 13.1742 11.6285 13.3125 11.9766 13.3125ZM18.5391 13.3125C18.8872 13.3125 19.221 13.1742 19.4671 12.9281C19.7133 12.6819 19.8516 12.3481 19.8516 12C19.8516 11.6519 19.7133 11.3181 19.4671 11.0719C19.221 10.8258 18.8872 10.6875 18.5391 10.6875C18.191 10.6875 17.8571 10.8258 17.611 11.0719C17.3648 11.3181 17.2266 11.6519 17.2266 12C17.2266 12.3481 17.3648 12.6819 17.611 12.9281C17.8571 13.1742 18.191 13.3125 18.5391 13.3125Z" fill="black"/>
                                                </svg>
                                                
                                                <div className={tooltipe?'tooltipe_strategy active':'tooltipe_strategy'}>
                                                    <div className='tooltipe_strategy_line' onClick={()=>addCompain(id, title)}>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10 5V15" stroke="#AEAEB2" stroke-width="0.714286" stroke-linecap="round"/>
                                                            <path d="M5 10H15" stroke="#AEAEB2" stroke-width="0.714286" stroke-linecap="round"/>
                                                        </svg>
                                                        {langv?.strategy?.button_4}
                                                    </div>
                                                    <div onClick={handleUpdateChangeTrue} className='tooltipe_strategy_line'>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_4130_60803)">
                                                            <path d="M11.8009 5.26526L4.86567 12.2009C4.65721 12.4094 4.51334 12.6736 4.45135 12.9618L3.88479 15.5942C3.86941 15.6657 3.87219 15.7398 3.89286 15.81C3.91353 15.8801 3.95145 15.9439 4.00314 15.9956C4.05483 16.0473 4.11865 16.0852 4.18877 16.1059C4.25889 16.1266 4.33307 16.1293 4.40454 16.1139L7.04354 15.5452C7.33153 15.4832 7.59554 15.3395 7.80392 15.1313L15.5184 7.41688C15.8988 7.02599 16.11 6.50101 16.1063 5.95554C16.1027 5.41008 15.8843 4.88801 15.4986 4.5023C15.1129 4.11659 14.5908 3.89827 14.0454 3.89458C13.4999 3.89089 12.9749 4.10212 12.584 4.48257L11.8276 5.23857L11.8009 5.26526ZM12.8934 4.79188C13.2017 4.49102 13.6162 4.3238 14.047 4.32645C14.4778 4.32911 14.8902 4.50142 15.1949 4.80605C15.4995 5.11069 15.6718 5.52309 15.6745 5.9539C15.6771 6.38471 15.5099 6.79921 15.209 7.10757L14.5944 7.72226L12.2787 5.40657L12.8934 4.79188ZM11.9685 5.71588L14.2842 8.03157L7.49417 14.8216C7.34533 14.9705 7.15665 15.0734 6.95079 15.1178L4.31223 15.6865L4.87835 13.0536C4.92271 12.8478 5.02556 12.6591 5.17454 12.5103L11.9685 5.71588Z" fill="#8E8E93"/>
                                                            </g>
                                                            <defs>
                                                            <clipPath id="clip0_4130_60803">
                                                            <rect width="14" height="14" fill="white" transform="translate(3 3)"/>
                                                            </clipPath>
                                                            </defs>
                                                        </svg>
                                                         {langv?.strategy?.button_5}
                                                    </div>
                                                    <div onClick={() => setPopupDelete0(id)} className='tooltipe_strategy_line'>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M8.6 5.27617H11.4C11.4 4.90487 11.2525 4.54877 10.9899 4.28622C10.7274 4.02367 10.3713 3.87617 10 3.87617C9.6287 3.87617 9.2726 4.02367 9.01005 4.28622C8.7475 4.54877 8.6 4.90487 8.6 5.27617ZM7.55 5.27617C7.55 4.95443 7.61337 4.63585 7.7365 4.3386C7.85962 4.04135 8.04008 3.77126 8.26759 3.54376C8.49509 3.31626 8.76518 3.13579 9.06243 3.01267C9.35967 2.88954 9.67826 2.82617 10 2.82617C10.3217 2.82617 10.6403 2.88954 10.9376 3.01267C11.2348 3.13579 11.5049 3.31626 11.7324 3.54376C11.9599 3.77126 12.1404 4.04135 12.2635 4.3386C12.3866 4.63585 12.45 4.95443 12.45 5.27617H16.475C16.6142 5.27617 16.7478 5.33148 16.8462 5.42994C16.9447 5.5284 17 5.66193 17 5.80117C17 5.94041 16.9447 6.07395 16.8462 6.1724C16.7478 6.27086 16.6142 6.32617 16.475 6.32617H15.551L14.732 14.8039C14.6692 15.4535 14.3666 16.0563 13.8834 16.495C13.4001 16.9336 12.7708 17.1764 12.1182 17.1762H7.8818C7.2293 17.1762 6.60017 16.9333 6.11706 16.4947C5.63396 16.0561 5.33151 15.4533 5.2687 14.8039L4.449 6.32617H3.525C3.38576 6.32617 3.25223 6.27086 3.15377 6.1724C3.05531 6.07395 3 5.94041 3 5.80117C3 5.66193 3.05531 5.5284 3.15377 5.42994C3.25223 5.33148 3.38576 5.27617 3.525 5.27617H7.55ZM8.95 8.60117C8.95 8.46193 8.89469 8.3284 8.79623 8.22994C8.69777 8.13148 8.56424 8.07617 8.425 8.07617C8.28576 8.07617 8.15223 8.13148 8.05377 8.22994C7.95531 8.3284 7.9 8.46193 7.9 8.60117V13.8512C7.9 13.9904 7.95531 14.1239 8.05377 14.2224C8.15223 14.3209 8.28576 14.3762 8.425 14.3762C8.56424 14.3762 8.69777 14.3209 8.79623 14.2224C8.89469 14.1239 8.95 13.9904 8.95 13.8512V8.60117ZM11.575 8.07617C11.7142 8.07617 11.8478 8.13148 11.9462 8.22994C12.0447 8.3284 12.1 8.46193 12.1 8.60117V13.8512C12.1 13.9904 12.0447 14.1239 11.9462 14.2224C11.8478 14.3209 11.7142 14.3762 11.575 14.3762C11.4358 14.3762 11.3022 14.3209 11.2038 14.2224C11.1053 14.1239 11.05 13.9904 11.05 13.8512V8.60117C11.05 8.46193 11.1053 8.3284 11.2038 8.22994C11.3022 8.13148 11.4358 8.07617 11.575 8.07617ZM6.3138 14.7031C6.35156 15.0927 6.53307 15.4544 6.82296 15.7174C7.11284 15.9805 7.49032 16.1263 7.8818 16.1262H12.1182C12.5097 16.1263 12.8872 15.9805 13.177 15.7174C13.4669 15.4544 13.6484 15.0927 13.6862 14.7031L14.4968 6.32617H5.5032L6.3138 14.7031Z" fill="#FF3B30"/>
                                                        </svg>
                                                         {langv?.strategy?.button_6}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className={long?'drag_body_description':'drag_body_description size_small'}>
                                        {description}&nbsp;
                                        {
                                           
                                            !!itemAll?.macro?.length?
                                                <>[</> 
                                                :
                                                <></>
                                        }
                                        
                                        {itemAll.macro?.map((m, i) =>
                                            <span key={m.column}>{m.column} &nbsp;
                                            {
                                                m.operator
                                            } 
                                            &nbsp;
                                            {
                                                m.operator=='in'?m.value.map((k, h)=>
                                                    <span>{k}{h < m.value.length - 1 && ', '}</span>
                                                    )
                                                    :
                                                    m.value
                                            } 
                                            {i < itemAll.macro.length - 1 && ', '}</span>
                                        )}
                                        {
                                            !!itemAll?.macro?.length?
                                                <>]</> 
                                                :
                                                <></>
                                        }
                                    </div>

                                    
                                </div>
                            </div>
                            {
                                long?
                                <div className='drag_arrow_subline list_subline'>
                                    {
                                        company.map((n, id00)=>
                                            <div className='strategy_company'>
                                                {
                                                    ower?
                                                    <div className='strategy_company_line_owerflow'></div>
                                                    :
                                                    <></>
                                                }
                                                
                                                <div className='strategy_company_line'>
                                                    
                                                    <div className='strategy_company_line_left'>
                                                        <div className='strategy_company_title'>
                                                            {n.name}
                                                        </div>
                                                        <div className='strategy_company_status'>
                                                            {n.status}
                                                        </div>
                                                    </div>
                                                    <div className='strategy_company_line_right toltipe_company_strategy_icon'
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            toggleTip(id00);
                                                        }}
                                                        role="button"
                                                        tabIndex={0}
                                                        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && toggleTip(id00)}
                                                        aria-expanded={openTip === id00}
                                                        aria-controls={`tip-${id00}`}
                                                    
                                                    >
                                                        <svg className='tooltipe_icon_open2' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect y="24" width="24" height="24" rx="4" transform="rotate(-90 0 24)" fill="#EFEFF0"/>
                                                            <path d="M5.41406 13.3125C5.76216 13.3125 6.096 13.1742 6.34214 12.9281C6.58828 12.6819 6.72656 12.3481 6.72656 12C6.72656 11.6519 6.58828 11.3181 6.34214 11.0719C6.096 10.8258 5.76216 10.6875 5.41406 10.6875C5.06597 10.6875 4.73213 10.8258 4.48598 11.0719C4.23984 11.3181 4.10156 11.6519 4.10156 12C4.10156 12.3481 4.23984 12.6819 4.48598 12.9281C4.73213 13.1742 5.06597 13.3125 5.41406 13.3125ZM11.9766 13.3125C12.3247 13.3125 12.6585 13.1742 12.9046 12.9281C13.1508 12.6819 13.2891 12.3481 13.2891 12C13.2891 11.6519 13.1508 11.3181 12.9046 11.0719C12.6585 10.8258 12.3247 10.6875 11.9766 10.6875C11.6285 10.6875 11.2946 10.8258 11.0485 11.0719C10.8023 11.3181 10.6641 11.6519 10.6641 12C10.6641 12.3481 10.8023 12.6819 11.0485 12.9281C11.2946 13.1742 11.6285 13.3125 11.9766 13.3125ZM18.5391 13.3125C18.8872 13.3125 19.221 13.1742 19.4671 12.9281C19.7133 12.6819 19.8516 12.3481 19.8516 12C19.8516 11.6519 19.7133 11.3181 19.4671 11.0719C19.221 10.8258 18.8872 10.6875 18.5391 10.6875C18.191 10.6875 17.8571 10.8258 17.611 11.0719C17.3648 11.3181 17.2266 11.6519 17.2266 12C17.2266 12.3481 17.3648 12.6819 17.611 12.9281C17.8571 13.1742 18.191 13.3125 18.5391 13.3125Z" fill="black"/>
                                                        </svg>
                                                        <div 
                                                            id={`tip-${id00}`}
                                                            className={`toltipe_company_strategy ${openTip === id00 ? 'is-open' : ''}`}
                                                            onClick={(e) => e.stopPropagation()}
                                                         >
                                                            <div className='tooltipe_strategy_line' onClick={()=>openCompain(n.name, n, title)}>
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g clip-path="url(#clip0_4130_60803)">
                                                                    <path d="M11.8009 5.26526L4.86567 12.2009C4.65721 12.4094 4.51334 12.6736 4.45135 12.9618L3.88479 15.5942C3.86941 15.6657 3.87219 15.7398 3.89286 15.81C3.91353 15.8801 3.95145 15.9439 4.00314 15.9956C4.05483 16.0473 4.11865 16.0852 4.18877 16.1059C4.25889 16.1266 4.33307 16.1293 4.40454 16.1139L7.04354 15.5452C7.33153 15.4832 7.59554 15.3395 7.80392 15.1313L15.5184 7.41688C15.8988 7.02599 16.11 6.50101 16.1063 5.95554C16.1027 5.41008 15.8843 4.88801 15.4986 4.5023C15.1129 4.11659 14.5908 3.89827 14.0454 3.89458C13.4999 3.89089 12.9749 4.10212 12.584 4.48257L11.8276 5.23857L11.8009 5.26526ZM12.8934 4.79188C13.2017 4.49102 13.6162 4.3238 14.047 4.32645C14.4778 4.32911 14.8902 4.50142 15.1949 4.80605C15.4995 5.11069 15.6718 5.52309 15.6745 5.9539C15.6771 6.38471 15.5099 6.79921 15.209 7.10757L14.5944 7.72226L12.2787 5.40657L12.8934 4.79188ZM11.9685 5.71588L14.2842 8.03157L7.49417 14.8216C7.34533 14.9705 7.15665 15.0734 6.95079 15.1178L4.31223 15.6865L4.87835 13.0536C4.92271 12.8478 5.02556 12.6591 5.17454 12.5103L11.9685 5.71588Z" fill="#8E8E93"/>
                                                                    </g>
                                                                    <defs>
                                                                    <clipPath id="clip0_4130_60803">
                                                                    <rect width="14" height="14" fill="white" transform="translate(3 3)"/>
                                                                    </clipPath>
                                                                    </defs>
                                                                </svg>
                                                                {langv?.strategy?.button_7}
                                                            </div>
                                                            <div className='tooltipe_strategy_line' onClick={()=>deleteCompain(n.id, id00)}>
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M8.6 5.27617H11.4C11.4 4.90487 11.2525 4.54877 10.9899 4.28622C10.7274 4.02367 10.3713 3.87617 10 3.87617C9.6287 3.87617 9.2726 4.02367 9.01005 4.28622C8.7475 4.54877 8.6 4.90487 8.6 5.27617ZM7.55 5.27617C7.55 4.95443 7.61337 4.63585 7.7365 4.3386C7.85962 4.04135 8.04008 3.77126 8.26759 3.54376C8.49509 3.31626 8.76518 3.13579 9.06243 3.01267C9.35967 2.88954 9.67826 2.82617 10 2.82617C10.3217 2.82617 10.6403 2.88954 10.9376 3.01267C11.2348 3.13579 11.5049 3.31626 11.7324 3.54376C11.9599 3.77126 12.1404 4.04135 12.2635 4.3386C12.3866 4.63585 12.45 4.95443 12.45 5.27617H16.475C16.6142 5.27617 16.7478 5.33148 16.8462 5.42994C16.9447 5.5284 17 5.66193 17 5.80117C17 5.94041 16.9447 6.07395 16.8462 6.1724C16.7478 6.27086 16.6142 6.32617 16.475 6.32617H15.551L14.732 14.8039C14.6692 15.4535 14.3666 16.0563 13.8834 16.495C13.4001 16.9336 12.7708 17.1764 12.1182 17.1762H7.8818C7.2293 17.1762 6.60017 16.9333 6.11706 16.4947C5.63396 16.0561 5.33151 15.4533 5.2687 14.8039L4.449 6.32617H3.525C3.38576 6.32617 3.25223 6.27086 3.15377 6.1724C3.05531 6.07395 3 5.94041 3 5.80117C3 5.66193 3.05531 5.5284 3.15377 5.42994C3.25223 5.33148 3.38576 5.27617 3.525 5.27617H7.55ZM8.95 8.60117C8.95 8.46193 8.89469 8.3284 8.79623 8.22994C8.69777 8.13148 8.56424 8.07617 8.425 8.07617C8.28576 8.07617 8.15223 8.13148 8.05377 8.22994C7.95531 8.3284 7.9 8.46193 7.9 8.60117V13.8512C7.9 13.9904 7.95531 14.1239 8.05377 14.2224C8.15223 14.3209 8.28576 14.3762 8.425 14.3762C8.56424 14.3762 8.69777 14.3209 8.79623 14.2224C8.89469 14.1239 8.95 13.9904 8.95 13.8512V8.60117ZM11.575 8.07617C11.7142 8.07617 11.8478 8.13148 11.9462 8.22994C12.0447 8.3284 12.1 8.46193 12.1 8.60117V13.8512C12.1 13.9904 12.0447 14.1239 11.9462 14.2224C11.8478 14.3209 11.7142 14.3762 11.575 14.3762C11.4358 14.3762 11.3022 14.3209 11.2038 14.2224C11.1053 14.1239 11.05 13.9904 11.05 13.8512V8.60117C11.05 8.46193 11.1053 8.3284 11.2038 8.22994C11.3022 8.13148 11.4358 8.07617 11.575 8.07617ZM6.3138 14.7031C6.35156 15.0927 6.53307 15.4544 6.82296 15.7174C7.11284 15.9805 7.49032 16.1263 7.8818 16.1262H12.1182C12.5097 16.1263 12.8872 15.9805 13.177 15.7174C13.4669 15.4544 13.6484 15.0927 13.6862 14.7031L14.4968 6.32617H5.5032L6.3138 14.7031Z" fill="#FF3B30"/>
                                                                </svg>
                                                                {langv?.strategy?.button_6}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='strategy_company_line'>
                                                    <div className='strategy_company_line_left'>
                                                        <div className='strategy_company_people'>
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g opacity="0.8">
                                                                <path d="M8.0026 6.66732C9.47536 6.66732 10.6693 5.47341 10.6693 4.00065C10.6693 2.52789 9.47536 1.33398 8.0026 1.33398C6.52984 1.33398 5.33594 2.52789 5.33594 4.00065C5.33594 5.47341 6.52984 6.66732 8.0026 6.66732Z" stroke="#007AFF"/>
                                                                <path d="M13.3346 11.667C13.3346 13.3237 13.3346 14.667 8.0013 14.667C2.66797 14.667 2.66797 13.3237 2.66797 11.667C2.66797 10.0103 5.05597 8.66699 8.0013 8.66699C10.9466 8.66699 13.3346 10.0103 13.3346 11.667Z" stroke="#007AFF"/>
                                                                </g>
                                                            </svg>
                                                            {n.clientsInCampaign}
                                                        </div>
                                                        <div className='strategy_company_mail'>
                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M16 4H4C2.89543 4 2 4.89543 2 6V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V6C18 4.89543 17.1046 4 16 4Z" stroke="#007AFF"/>
                                                                <path d="M2 7L9.106 10.553C9.3836 10.6917 9.68967 10.7639 10 10.7639C10.3103 10.7639 10.6164 10.6917 10.894 10.553L18 7" stroke="#007AFF"/>
                                                            </svg>
                                                            {n.messagesInCampaign}
                                                        </div>
                                                        <div className='strategy_company_info'>
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M8 1C6.61553 1 5.26216 1.41054 4.11101 2.17971C2.95987 2.94888 2.06266 4.04213 1.53285 5.32122C1.00303 6.6003 0.86441 8.00776 1.13451 9.36563C1.4046 10.7235 2.07129 11.9708 3.05026 12.9497C4.02922 13.9287 5.2765 14.5954 6.63437 14.8655C7.99224 15.1356 9.3997 14.997 10.6788 14.4672C11.9579 13.9373 13.0511 13.0401 13.8203 11.889C14.5895 10.7378 15 9.38447 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1ZM8 13.8333C6.84628 13.8333 5.71846 13.4912 4.75918 12.8502C3.79989 12.2093 3.05222 11.2982 2.61071 10.2323C2.16919 9.16642 2.05368 7.99353 2.27876 6.86197C2.50384 5.73042 3.05941 4.69102 3.87521 3.87521C4.69102 3.0594 5.73042 2.50383 6.86198 2.27875C7.99353 2.05367 9.16642 2.16919 10.2323 2.6107C11.2982 3.05221 12.2093 3.79989 12.8502 4.75917C13.4912 5.71846 13.8333 6.84627 13.8333 8C13.8333 9.54709 13.2188 11.0308 12.1248 12.1248C11.0308 13.2187 9.5471 13.8333 8 13.8333Z" fill="#C7C7CC"/>
                                                                <path d="M7.99735 6.65761C7.84264 6.65761 7.69426 6.71907 7.58487 6.82847C7.47547 6.93786 7.41401 7.08624 7.41401 7.24095V11.2076C7.41401 11.3623 7.47547 11.5107 7.58487 11.6201C7.69426 11.7295 7.84264 11.7909 7.99735 11.7909C8.15206 11.7909 8.30043 11.7295 8.40983 11.6201C8.51922 11.5107 8.58068 11.3623 8.58068 11.2076V7.24095C8.58068 7.08624 8.51922 6.93786 8.40983 6.82847C8.30043 6.71907 8.15206 6.65761 7.99735 6.65761ZM7.99735 4.26595C7.83943 4.27188 7.68978 4.33806 7.57913 4.45088C7.46847 4.5637 7.40522 4.71461 7.40235 4.87261V4.96595C7.40207 5.04206 7.41764 5.11739 7.44807 5.18715C7.4785 5.25691 7.52311 5.31958 7.57908 5.37116C7.63505 5.42274 7.70114 5.4621 7.77315 5.48674C7.84516 5.51138 7.92151 5.52076 7.99735 5.51428C8.15021 5.50851 8.29526 5.44519 8.40342 5.33702C8.51159 5.22885 8.57491 5.08381 8.58068 4.93095V4.79095C8.58114 4.71681 8.56589 4.64341 8.53594 4.57559C8.50598 4.50777 8.46201 4.44706 8.4069 4.39747C8.35179 4.34787 8.2868 4.31051 8.21621 4.28784C8.14562 4.26517 8.07103 4.25771 7.99735 4.26595Z" fill="#C7C7CC"/>
                                                            </svg>
                                                            <div className='strategy_company_micro'>
                                                                <div className='strategy_company_micro_title'>
                                                                    {langv?.strategy?.field1}
                                                                </div>  
                                                            
                                                                {
                                                                    n.microsegmentation?.map((g)=>
                                                                        <div className='strategy_company_micro_value_line'>
                                                                            <span>
                                                                                {g.title}:&nbsp;
                                                                            </span>
                                                                            {g.value}
                                                                        </div>
                                                                    )
                                                                }
                                                            
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='strategy_company_line_right strategy_company_line_right_data'>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.48427 4.36017C3.93128 4.905 3.50857 5.56776 3.24772 6.29893C2.98687 7.03009 2.89462 7.81074 2.97787 8.58256C2.98561 8.68624 2.95269 8.78886 2.88608 8.86868C2.81946 8.94849 2.72439 8.99924 2.621 9.01016C2.51761 9.02108 2.41403 8.99132 2.33221 8.92718C2.25039 8.86305 2.19675 8.76957 2.18267 8.66656C2.08665 7.77512 2.19327 6.8735 2.49457 6.02904C2.79586 5.18458 3.28405 4.4191 3.92267 3.78977C6.27227 1.47217 10.0627 1.50977 12.3883 3.86817C14.7139 6.22657 14.6987 10.0162 12.3483 12.3338C11.2601 13.4082 9.79969 14.022 8.27067 14.0474C7.69253 14.058 7.1159 13.9849 6.55867 13.8306C6.4564 13.8023 6.36953 13.7347 6.31717 13.6424C6.26481 13.5501 6.25125 13.4408 6.27947 13.3386C6.30769 13.2363 6.37537 13.1494 6.46764 13.0971C6.55991 13.0447 6.6692 13.0311 6.77147 13.0594C7.25475 13.1933 7.75486 13.2566 8.25627 13.2474C9.58027 13.2266 10.8451 12.6952 11.7867 11.7642C13.8195 9.75936 13.8363 6.47617 11.8187 4.42977C9.80107 2.38337 6.51707 2.35537 4.48427 4.36017Z" fill="#AEAEB2"/>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.87556 9.09045C2.84057 9.12964 2.79821 9.16155 2.7509 9.18437C2.70358 9.20719 2.65223 9.22046 2.59978 9.22343C2.54734 9.2264 2.49482 9.21902 2.44523 9.20169C2.39564 9.18436 2.34994 9.15744 2.31076 9.12245L0.934756 7.89845C0.892457 7.8645 0.857506 7.82229 0.832028 7.77441C0.80655 7.72652 0.791077 7.67395 0.786551 7.6199C0.782025 7.56585 0.78854 7.51144 0.8057 7.45998C0.82286 7.40853 0.850306 7.3611 0.886369 7.32058C0.922433 7.28006 0.96636 7.2473 1.01548 7.22429C1.0646 7.20129 1.11789 7.18851 1.1721 7.18674C1.22631 7.18497 1.28032 7.19424 1.33084 7.214C1.38136 7.23375 1.42733 7.26357 1.46596 7.30165L2.84196 8.52565C2.88126 8.56053 2.9133 8.6028 2.93626 8.65006C2.95922 8.69732 2.97264 8.74864 2.97576 8.80109C2.97888 8.85354 2.97164 8.90609 2.95445 8.95574C2.93725 9.00539 2.91045 9.05117 2.87556 9.09045Z" fill="#AEAEB2"/>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.25578 9.0402C2.2873 9.08222 2.32679 9.11762 2.37199 9.14438C2.41719 9.17115 2.46721 9.18875 2.51921 9.19618C2.57122 9.2036 2.62417 9.20072 2.67506 9.18768C2.72594 9.17464 2.77376 9.15171 2.81578 9.1202L4.41578 7.9202C4.50065 7.85654 4.55676 7.76178 4.57176 7.65676C4.58677 7.55174 4.55943 7.44506 4.49578 7.3602C4.43213 7.27533 4.33737 7.21922 4.23235 7.20422C4.12733 7.18921 4.02065 7.21654 3.93578 7.2802L2.33578 8.4802C2.25091 8.54385 2.19481 8.63861 2.1798 8.74363C2.1648 8.84865 2.19213 8.95533 2.25578 9.0402ZM7.99978 5.2002C8.10587 5.2002 8.20761 5.24234 8.28263 5.31735C8.35764 5.39237 8.39978 5.49411 8.39978 5.6002V8.4002C8.39978 8.50628 8.35764 8.60802 8.28263 8.68304C8.20761 8.75805 8.10587 8.8002 7.99978 8.8002C7.8937 8.8002 7.79195 8.75805 7.71694 8.68304C7.64193 8.60802 7.59978 8.50628 7.59978 8.4002V5.6002C7.59978 5.49411 7.64193 5.39237 7.71694 5.31735C7.79195 5.24234 7.8937 5.2002 7.99978 5.2002Z" fill="#AEAEB2"/>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8016 8.4C10.8016 8.50609 10.7594 8.60783 10.6844 8.68284C10.6094 8.75786 10.5076 8.8 10.4016 8.8H8.00156C7.89548 8.8 7.79373 8.75786 7.71872 8.68284C7.6437 8.60783 7.60156 8.50609 7.60156 8.4C7.60156 8.29391 7.6437 8.19217 7.71872 8.11716C7.79373 8.04214 7.89548 8 8.00156 8H10.4016C10.5076 8 10.6094 8.04214 10.6844 8.11716C10.7594 8.19217 10.8016 8.29391 10.8016 8.4Z" fill="#AEAEB2"/>
                                                        </svg>
                                                        {formatDate(n.updatedAt)}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                                :
                                <></>
                            }
                        </div>
                    </div>   
            }
            
        </>
    );
});




const Strategy = observer(() => {
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    const [input, setInput] = useState("");
    const [profile, setProfile] = useState([]);
    const [guide, setGuide] = useState([]);
    const [products, setProducts] = useState([]);
    const [toolsProfile, setToolsProfile] = useState([]);
    const [profileName, setProfileName] = useState('');
    const [profileWeb, setProfileWeb] = useState('');
    const [profileDesc, setProfileDesc] = useState('');
    const [profileId, setProfileId] = useState('');
    const [guideToneOfVoice, setGuideToneOfVoice] = useState('');
    const [guidespamWord, setGuidespamWord] = useState('');
    const [guidelimitation, setGuidelimitation] = useState('');

    const [editor1, setEditor1] = useState(false);
    const [activemess, setActivemess] = useState(false);
    const [activbut, setActivbut] = useState(false);
    const [allmessages, setAllmessages] = useState();
    const ref = React.useRef(null);
    var unlock = false
    const editorRef = useRef(null);
    const [messages, setMessages] = useState([]);
    const [attribute, setAttribute] = useState([]);
    const [idTread, setidTread] = useState('');
    const sensors = useSensors(useSensor(PointerSensor, {activationConstraint:{distance: 8}}));
    const [shadow, setShadow] = useState(false);
    const [items,setItems] = useState([]);
    const [load, setLoad] = useState(true);
    const [load2, setLoad2] = useState(true);

    const [workspace, setWorkspace] = useState([]);


    const isNotJson = (str) => {
        if (typeof str !== 'string') return true;
        try {
            JSON.parse(str);
            return false; // це валідний JSON
        } catch (e) {
            return true; // не JSON
        }
    };
    async function getDataStrategy()
    {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `strategy/workspace`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
           
            var t = [];
            data.goals.map((g)=>
                t = [...t, 
                    { 
                    id: g.id, 
                    title: g.name, 
                    description: g.description, 
                    reg1:g.clientsInGoal, 
                    reg2:g.clientPercentInGoal, 
                    reg3:g.campaignsInGoal, 
                    open: false, 
                    new_st: false,
                    company:g.campaigns,
                    macro: g.macroSegmentRules
                }]
            )
            setItems(t);
            
            setLoad2(false);
        }
        else
        {
            alert("Something went wrong, request status:" + response.status)
        }
    }

    async function getDataWorkspace()
    {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `strategy/workspace`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            console.log(data + "test strategy/workspace GET")
            setWorkspace(data)
        }
        else
        {
            alert("Something went wrong, request status:" + response.status)
        }
    }

   useEffect(() => {
        getDataStrategy();
        getDataWorkspace();
    }, []);

    
   


    const addmessages = async() =>{
        if(load){
            return;
        }
         setLoad(true);
        //  setLoad2(true);
         setActivbut(false);
        var t = messages;
        t = [...t, {
            id:"",
            type:1,
            company:"",
            website:"",
            text:input,
            score:""
        }];
        setMessages(t);
        
        setInput('');
        setTimeout(function(){
            setInput('');
            document.getElementById('textarea').style.height = '22px';
        },500)
        const el = containerRef.current;
        if (el) {
            el.scrollTop = el.scrollHeight+50;
        }

        var token = localStorage.getItem("token");
       
        
   
       
            
            var attr = {
                message:input
            };
            var mes = allmessages;
           
            if(idTread!=undefined)
            {
                var source = new SSE(Domen.url + 'agent/strategy/ask', {headers: {'Authorization': token,'Content-Type': 'application/json'}, payload: JSON.stringify(attr)});
            }
            else
            {
                var source = new SSE(Domen.url + 'agent/strategy/ask', {headers: {'Authorization': token,'Content-Type': 'application/json'}, payload: JSON.stringify(attr)});
            }
            
            source.addEventListener('message', function(e) {
                if(e.data!='')
                {

                    var payload = JSON.parse(e.data);
                    if(payload.type=="message")
                    {
                        if(payload.content.content=='')
                        {
                        var y = payload.content.tool_calls[0];
                        if( 
                            y?.name=='get_goals'||
                            y?.name=='create_goal'||
                            y?.name=='update_goal'||
                            y?.name=='delete_goal'||
                            y?.name=='update_microsegment_selection'||
                            y?.name=='get_strategy_workspace'
                        ){
                            getDataStrategy();
                            setLoad2(true);
                        }
                        
                        // else{
                        //     setActiveMenu(3)
                        // }
                        
                        }
                        if(payload.content.content!='')
                        {
                            if(isNotJson(payload.content.content))
                            {
                                if(payload.content.type!="human")
                                {
                                    t = [...t, {
                                        id: payload.content.message_id,
                                        type:2,
                                        company:"",
                                        website:"",
                                        text:payload.content.content,
                                        score: null,
                                        isNew: true,
                                    }];
                                    setMessages(t);
                                    getDataStrategy();
                                    setLoad(false);
                                    setTimeout(function(){
                                        setLoad2(false)
                                    }, 3000)
                                }
                            }
                        }
                    }
                    setInput('');
                    const el = containerRef.current;
                    if (el) {
                        el.scrollTop = el.scrollHeight;
                    }
                }
                
            });
    }

    useEffect(() => {
        const el = containerRef.current;
        if (el) {
        el.scrollTop = el.scrollHeight;
        }
    }, [messages]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter'&&input!='') {
            if (e.shiftKey) 
            {
                return;
            } 
            else 
            {
                const cleanedText = input.replace(/\n/g, ' ');
                setInput(cleanedText);
                addmessages();
            }
        }
        setActivbut(false);
    };
    

    const LikeMes = async(id)=>{
        var token = localStorage.getItem("token");
        console.log(id);
        var param = {
            score : 5
        };
        const response = await fetch(Domen.url + `agent/strategy/feedback/`+id, {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(param),
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            getHistory();
        }
    }

    const DisLikeMes = async(id)=>{
        console.log(id);
        var token = localStorage.getItem("token");
        var param = {
            score : 0
        };
        const response = await fetch(Domen.url + `agent/strategy/feedback/`+id, {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(param),
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            getHistory();
        }
    }

    const getHistory = async()=>{
        var token = localStorage.getItem("token");
        var t = [];

        const response = await fetch(Domen.url + `agent/strategy/history`, {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                console.log(data);

                setidTread(data.id);


                data?.messages?.map((n)=>{
                    n.versions?.map((c)=>{
                        t = [...t, {
                            id:n.id,
                            type:1,
                            company:"",
                            website:"",
                            text:c.text,
                            score:c.score
                        }];
                        t = [...t, {
                            id:n.id,
                            type:2,
                            company:"",
                            website:"",
                            text:c.response,
                            score:c.score
                        }];
                    })
                    
                })

                
                setMessages(t);
                setLoad(false);
            } 
    }

    const getAttribute = async()=>{
        var token = localStorage.getItem("token");
        var t = messages;
        const response = await fetch(Domen.url + `portraits/table`, {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            if(response.status=="200")
            {
                const data = await response.json();
                var mass = [];
                data.data?.map((f)=>
                    mass = [...mass, {id: f.id, name: f.name, description: f.description, check1: f.segment, check2: f.dynamicField}]
                )
                setAttribute(mass);
                
            } 
    }

    const setInput0 = (a)=>{
        setInput(a);
        if(a!='')
        {
            setActivbut(true)
        }
        else{
            setActivbut(false)
        }
    }

    useEffect(() => {
        if (editorRef.current) {
            editorRef.current.focus();
        }
    }, [editor1]);
   
    function autoGrow(el) {
        el.style.height = '1px';
        el.style.height = el.scrollHeight + 'px';
    }

    useEffect(()=>{

        getAttribute();



        document.getElementById('textarea').addEventListener('input', function() {
            autoGrow(this);
        });
        if(document.getElementsByClassName("textareas")[0])
        {
            document.getElementsByClassName("textareas")[0].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[1])
        {
            document.getElementsByClassName("textareas")[1].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[2])
        {
            document.getElementsByClassName("textareas")[2].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[3])
        {
            document.getElementsByClassName("textareas")[3].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[4])
        {
            document.getElementsByClassName("textareas")[4].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[5])
        {
            document.getElementsByClassName("textareas")[5].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[6])
        {
            document.getElementsByClassName("textareas")[6].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[7])
        {
            document.getElementsByClassName("textareas")[7].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[8])
        {
            document.getElementsByClassName("textareas")[8].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[9])
        {
            document.getElementsByClassName("textareas")[9].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[10])
        {
            document.getElementsByClassName("textareas")[10].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        if(document.getElementsByClassName("textareas")[11])
        {
            document.getElementsByClassName("textareas")[11].addEventListener('input', function() {
                autoGrow(this);
            });
        }
        
        var ld = window.document.getElementById('messages');
        var cw = ld.offsetWidth;
        var w = window.innerWidth
        
        window.document.getElementById('messages').style.width = "50%";
        window.document.getElementById('controls').style.width = "50%";


        addEventListener("mousemove", (e) => {
            var change = cw + (e.clientX - cw - 40);
            var max = w - 700;
            if(unlock) {
                console.log(change);
                if(change > 700 && change<max) {
                    console.log(w)
                    var t = w - change;
                    window.document.getElementById('messages').style.width = change+"px";
                    window.document.getElementById('controls').style.width = t+"px";
                }
                
                
            }
        });
        ref.current.addEventListener("mousedown", ()=>{
            unlock = true;
        });

        addEventListener("mousedown", (e)=>{
            if(unlock) {
                e.preventDefault();
            }
        });

        addEventListener("mouseup", ()=>{
            unlock = false;
        });
        
        

    },[])

    const getProfile = async() =>{
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `company_profile/`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            setProfile(data); 
            setProfileName(data.name);
            setProfileWeb(data.website);
            setProfileDesc(data.description);
            setProfileId(data.id)
        }
        else
        {
            alert(response.status)
        }
    }

    const getProfileProduct = async() =>{
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `company_profile/products/`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            const withCheck = data.map(item => ({ ...item, check: false }));
            setProducts(withCheck);
        }
        else
        {
            alert(response.status)
        }
    }

    const getProfileTools = async() =>{
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `company_profile/tools/`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            const withCheck = data.map(item => ({ ...item, check: false }));
            setToolsProfile(withCheck);
        }
        else
        {
            alert(response.status)
        }
    }

    const getGuide = async() =>{
        var token = localStorage.getItem("token");
        const response = await fetch(Domen.url + `company_profile/communication-guide`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status>=200&&response.status<399)
        {
            const data = await response.json();
            setGuide(data); 
            setGuideToneOfVoice(data.toneOfVoice);
            setGuidespamWord(data.spamWord);
            setGuidelimitation(data.limitation);
        }
        else
        {
            alert(response.status)
        }
    }

    useEffect(()=>{
        getProfile();
        getGuide();
        getHistory();
        getProfileProduct();
        getProfileTools();
    },[])

    const handleDragEnd = (event) => {
        const { active, over } = event;
        // if (active.id !== over.id) {
        //     const oldIndex = items.findIndex(item => item.id === active.id);
        //     const newIndex = items.findIndex(item => item.id === over.id);
        //     setItems(arrayMove(items, oldIndex, newIndex));
        // }
        if (active.id !== over.id) {
            setItems((prevItems) => {
            const oldIndex = prevItems.findIndex((item) => item.id === active.id);
            const newIndex = prevItems.findIndex((item) => item.id === over.id);

            const newOrder = arrayMove(prevItems, oldIndex, newIndex);

            // 👉 будуємо структуру для бекенду
            const payload = {
                items: newOrder.map((item, index) => ({
                id: item.id,
                index: index,
                })),
            };
            updateIndex(payload);
            console.log("Payload to backend:", payload);

            // тут можна одразу відправити
            // fetch("/api/save-order", {
            //   method: "POST",
            //   headers: { "Content-Type": "application/json" },
            //   body: JSON.stringify(payload),
            // });

            return newOrder;
            });
        }
    };
    const updateIndex = async(goals) =>{
        var token = localStorage.getItem("token");
        var param = goals;
        const response = await fetch(Domen.url + `strategy/workspaces/`+workspace.id+`/goals`, {
            method: 'PUT',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(param),
        })
        if(response.status>=200&&response.status<399)
        {
           getDataWorkspace();
           getDataStrategy();
        }
        else{
            getDataWorkspace();
            getDataStrategy();
        }
    }
    
    const AddNewLine = () =>{
        var t = items;
        t = [...t, { id: items.length+1, title: '', description: "", reg1:0, reg2:'0%', reg3:0, open: true, new_st: true }]
        setItems(t);
    }
    const handleChange = (id, field, value) => {

        setItems((prev) =>
            prev.map((item) =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };

    const handleDelete = (id) => {
        setItems((prev) => prev.filter((item) => item.id !== id && item.new_st !== true));
    };

    const handleClose = (id) => {
        
        items.map((y)=>
        {
            if(y.id==id&&y.new_st==true)
            {
                setItems((prev) => prev.filter((item) => item.id !== id && item.new_st !== true))
            }
            if(y.id==id&&y.new_st==false)
            {
                console.log("test005")
              
                handleChange(y.id, 'open', false)
            }
        })
    };
  
    const copyMessage = (text)=>{
        navigator.clipboard.writeText(text)
        .then(() => {
            console.log("Текст скопійовано!");
        })
        .catch(err => {
            console.error("Помилка копіювання:", err);
        });
    }
   
    const containerRef = useRef(null);
   

    return (
        <>
            <div className='strategy_page' >
                <div id="messages" className='assistant_messages'>
                    <div className='assistant_logo'>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="4" fill="#020202"/>
                            <path d="M20.1489 34.4348C19.1377 34.4738 18.1137 34.1095 17.3418 33.342C16.6919 32.6959 16.3295 31.8723 16.2545 31.0282C15.5941 26.0169 14.0322 24.4611 8.99626 23.8034C8.1443 23.7305 7.31256 23.3699 6.66058 22.7217C5.19127 21.2609 5.19127 18.8924 6.66058 17.4316C8.12989 15.9707 10.5121 15.9707 11.9814 17.4316C12.5957 18.0423 12.9531 18.8116 13.0538 19.6069L13.0559 19.6049C13.3176 21.6648 13.7243 23.1512 14.4481 24.2353C15.4438 25.9142 17.5653 27.0735 20.0215 27.0735C22.6513 27.0735 24.8973 25.7446 25.7889 23.8718C26.3582 22.8543 26.7033 21.5204 26.9363 19.7585C27.009 18.9103 27.3718 18.082 28.0246 17.4329C29.494 15.9721 31.8762 15.9721 33.3455 17.4329C34.8148 18.8938 34.8148 21.2622 33.3455 22.723C32.7315 23.3335 31.9581 23.6889 31.1585 23.7891L31.1598 23.7905C25.9638 24.4431 24.396 26.0019 23.7396 31.1678L23.7383 31.1665C23.6376 31.9618 23.2801 32.7311 22.6659 33.3418C21.9677 34.036 21.0634 34.4003 20.1489 34.4348Z" fill="#F8CD02"/>
                            <path d="M17.4939 22.2646C15.8822 20.7278 15.8822 18.2362 17.4939 16.6995C19.1056 15.1627 21.7187 15.1627 23.3304 16.6995C24.942 18.2362 24.942 20.7278 23.3304 22.2646C21.7187 23.8014 19.1056 23.8014 17.4939 22.2646Z" fill="white"/>
                            <g clip-path="url(#clip0_1473_1721)">
                            <path d="M13.8656 11.0263C12.177 10.7671 11.9464 10.5826 11.6223 9.23168C11.6177 9.21265 11.605 9.19549 11.5863 9.18315C11.5677 9.17081 11.5442 9.16406 11.52 9.16406C11.4958 9.16406 11.4723 9.17081 11.4536 9.18315C11.4349 9.19549 11.4222 9.21265 11.4177 9.23168C11.0937 10.5826 10.8631 10.7671 9.17436 11.0263C9.15058 11.03 9.12913 11.0401 9.11371 11.0551C9.09828 11.07 9.08984 11.0888 9.08984 11.1082C9.08984 11.1275 9.09828 11.1463 9.11371 11.1613C9.12913 11.1762 9.15058 11.1864 9.17436 11.19C10.8631 11.4493 11.0937 11.6338 11.4177 12.9847C11.4223 13.0037 11.435 13.0208 11.4536 13.0331C11.4723 13.0455 11.4958 13.0522 11.52 13.0522C11.5442 13.0522 11.5676 13.0455 11.5863 13.0331C11.605 13.0208 11.6177 13.0037 11.6223 12.9847C11.9464 11.6338 12.177 11.4493 13.8656 11.19C13.8894 11.1864 13.9108 11.1762 13.9262 11.1613C13.9417 11.1463 13.9501 11.1275 13.9501 11.1082C13.9501 11.0888 13.9417 11.07 13.9262 11.0551C13.9108 11.0401 13.8894 11.03 13.8656 11.0263Z" fill="#FFCC00"/>
                            </g>
                            <g clip-path="url(#clip1_1473_1721)">
                            <path d="M31.6507 11.0263C29.9621 10.7671 29.7315 10.5826 29.4074 9.23168C29.4029 9.21265 29.3902 9.19549 29.3715 9.18315C29.3528 9.17081 29.3294 9.16406 29.3051 9.16406C29.2809 9.16406 29.2574 9.17081 29.2388 9.18315C29.2201 9.19549 29.2074 9.21265 29.2028 9.23168C28.8788 10.5826 28.6482 10.7671 26.9595 11.0263C26.9357 11.03 26.9143 11.0401 26.8989 11.0551C26.8834 11.07 26.875 11.0888 26.875 11.1082C26.875 11.1275 26.8834 11.1463 26.8989 11.1613C26.9143 11.1762 26.9357 11.1864 26.9595 11.19C28.6482 11.4493 28.8788 11.6338 29.2028 12.9847C29.2074 13.0037 29.2201 13.0208 29.2388 13.0331C29.2575 13.0455 29.2809 13.0522 29.3051 13.0522C29.3293 13.0522 29.3528 13.0455 29.3715 13.0331C29.3901 13.0208 29.4029 13.0037 29.4074 12.9847C29.7315 11.6338 29.9621 11.4493 31.6507 11.19C31.6745 11.1864 31.696 11.1762 31.7114 11.1613C31.7268 11.1463 31.7353 11.1275 31.7353 11.1082C31.7353 11.0888 31.7268 11.07 31.7114 11.0551C31.696 11.0401 31.6745 11.03 31.6507 11.0263Z" fill="#FFCC00"/>
                            </g>
                            <g clip-path="url(#clip2_1473_1721)">
                            <path d="M24.6354 8.71669C21.5959 8.19818 21.1808 7.82924 20.5975 5.12742C20.5892 5.08936 20.5663 5.05505 20.5327 5.03037C20.4991 5.00569 20.4569 4.99219 20.4133 4.99219C20.3697 4.99219 20.3275 5.00569 20.2939 5.03037C20.2602 5.05505 20.2374 5.08936 20.2291 5.12742C19.6459 7.82924 19.2309 8.19818 16.1912 8.71669C16.1484 8.72401 16.1098 8.74436 16.082 8.77423C16.0542 8.80411 16.0391 8.84165 16.0391 8.8804C16.0391 8.91915 16.0542 8.95669 16.082 8.98657C16.1098 9.01645 16.1484 9.03679 16.1912 9.04411C19.2309 9.56264 19.6459 9.93156 20.2291 12.6334C20.2374 12.6714 20.2603 12.7057 20.2939 12.7303C20.3275 12.755 20.3697 12.7685 20.4133 12.7685C20.4569 12.7685 20.4991 12.755 20.5327 12.7303C20.5663 12.7057 20.5892 12.6714 20.5975 12.6334C21.1808 9.93156 21.5959 9.56264 24.6354 9.04411C24.6782 9.03679 24.7168 9.01645 24.7446 8.98657C24.7723 8.95669 24.7875 8.91915 24.7875 8.8804C24.7875 8.84165 24.7723 8.80411 24.7446 8.77423C24.7168 8.74436 24.6782 8.72401 24.6354 8.71669Z" fill="#FFCC00"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_1473_1721">
                            <rect width="5.55556" height="4.44444" fill="white" transform="translate(8.74219 8.88281)"/>
                            </clipPath>
                            <clipPath id="clip1_1473_1721">
                            <rect width="5.55556" height="4.44444" fill="white" transform="translate(26.5273 8.88281)"/>
                            </clipPath>
                            <clipPath id="clip2_1473_1721">
                            <rect width="10" height="8.88889" fill="white" transform="translate(15.4141 4.4375)"/>
                            </clipPath>
                            </defs>
                        </svg>
                        {langv?.assistant?.ai_assistant}
                    </div>
                    <div className='assistant_messages_body' ref={containerRef}>
                        {
                            messages?.map((n, idx)=>
                                n.type==1?
                                <div className='clientmess_line'>
                                    <div className='clientmess'>
                                        {/* <div className='clientmess_icons' onClick={()=>setActivemess(!activemess)}>
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.5436 6.44542L5.59914 12.3903C5.42046 12.569 5.29715 12.7954 5.24402 13.0424L4.75839 15.2988C4.74521 15.36 4.74759 15.4236 4.76531 15.4837C4.78303 15.5438 4.81553 15.5985 4.85983 15.6428C4.90414 15.6872 4.95885 15.7197 5.01895 15.7374C5.07905 15.7551 5.14263 15.7575 5.20389 15.7443L7.46589 15.2568C7.71274 15.2037 7.93904 15.0805 8.11764 14.902L14.73 8.28967C15.0561 7.95461 15.2372 7.50463 15.234 7.03709C15.2308 6.56955 15.0437 6.12206 14.7131 5.79145C14.3825 5.46085 13.935 5.27371 13.4675 5.27055C12.9999 5.26738 12.5499 5.44844 12.2149 5.77454L11.5665 6.42254L11.5436 6.44542ZM12.48 6.03967C12.7443 5.78179 13.0996 5.63845 13.4689 5.64073C13.8381 5.643 14.1916 5.7907 14.4527 6.05181C14.7139 6.31293 14.8616 6.66642 14.8638 7.03568C14.8661 7.40495 14.7228 7.76023 14.4649 8.02454L13.938 8.55142L11.9531 6.56654L12.48 6.03967ZM11.6873 6.83167L13.6721 8.81654L7.85214 14.6365C7.72457 14.7642 7.56285 14.8524 7.38639 14.8904L5.12477 15.3779L5.61002 13.1212C5.64804 12.9447 5.7362 12.783 5.86389 12.6554L11.6873 6.83167Z" fill="#8E8E93"/>
                                            </svg>
                                        </div> */}
                                        <div className='clientmess_text'>
                                            <p dangerouslySetInnerHTML={{__html: n.text}}></p>
                                            {
                                                activemess?
                                            
                                                <div className='clientmess_text_buts'>
                                                    <div className='clientmess_text_buts_col'>
                                                        <div className='clientmess_text_but' onClick={()=>setActivemess(!activemess)}>
                                                            {langv?.assistant?.cancel}
                                                        </div>
                                                        <div className='clientmess_text_but b_y'>
                                                            {langv?.assistant?.send}
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <></>
                                            }
                                        </div>
                                    </div>
                                </div>
                                :
                               
                                <div className='adminmess_line'>
                                    <div className='adminmess'>
                                        <div className='admin_icons' >
                                            <img src={logoeditor} alt=""/>
                                        </div>
                                        <div className='admin_text'>
                                            <div className='admin_text_h'>{langv?.assistant?.general}:</div>
                                            {
                                                n.company!=""?
                                                <span>{n.company}</span>
                                                :
                                                <></>
                                            }
                                            {
                                                n.website!=""?
                                                <span>{n.website}</span>
                                                :
                                                <></>
                                            }
                                            
                                            
                                            <br/>
                                            <MarkdownRenderer text={n.text} />
                                            {/* <MessageBlock key={idx} text={n.text} /> */}
                                            {/* {
                                                isMarkdownTable(n.text)
                                                ? <MarkdownBlock key={idx} text={n.text} /> //<MarkdownTable key={idx} markdown={n.text} />

                                                : <p dangerouslySetInnerHTML={{__html:n.text}}></p>
                                            } */}
                                            
                                            
                                            <div className='icon_admin_hover_line'>
                                                <div className='icon_admin_hover'>
                                                    <div className='like'>
                                                        <span className='tolpipa_icon'>{langv?.strategy?.field2}</span>
                                                        <svg onClick={()=>copyMessage(n.text)} className='def_like' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M11.6667 6.5H6.33333C5.59695 6.5 5 6.96494 5 7.53846V14.4615C5 15.0351 5.59695 15.5 6.33333 15.5H11.6667C12.403 15.5 13 15.0351 13 14.4615V7.53846C13 6.96494 12.403 6.5 11.6667 6.5Z" stroke="#8E8E93" stroke-width="0.7"/>
                                                            <path d="M7 5.53846C7 5.26304 7.14048 4.99891 7.39052 4.80416C7.64057 4.60941 7.97971 4.5 8.33333 4.5H13.6667C14.0203 4.5 14.3594 4.60941 14.6095 4.80416C14.8595 4.99891 15 5.26304 15 5.53846V12.4615C15 12.737 14.8595 13.0011 14.6095 13.1958C14.3594 13.3906 14.0203 13.5 13.6667 13.5" stroke="#8E8E93" stroke-width="0.7"/>
                                                        </svg>
                                                        <svg onClick={()=>copyMessage(n.text)} className='hov_like' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect width="20" height="20" rx="4" fill="#E5E5EA"/>
                                                            <path d="M11.6667 6.5H6.33333C5.59695 6.5 5 6.96494 5 7.53846V14.4615C5 15.0351 5.59695 15.5 6.33333 15.5H11.6667C12.403 15.5 13 15.0351 13 14.4615V7.53846C13 6.96494 12.403 6.5 11.6667 6.5Z" stroke="#8E8E93" stroke-width="0.7"/>
                                                            <path d="M7 5.53846C7 5.26304 7.14048 4.99891 7.39052 4.80416C7.64057 4.60941 7.97971 4.5 8.33333 4.5H13.6667C14.0203 4.5 14.3594 4.60941 14.6095 4.80416C14.8595 4.99891 15 5.26304 15 5.53846V12.4615C15 12.737 14.8595 13.0011 14.6095 13.1958C14.3594 13.3906 14.0203 13.5 13.6667 13.5" stroke="#8E8E93" stroke-width="0.7"/>
                                                        </svg>

                                                    </div>
                                                    <div className='like'>
                                                        <span className='tolpipa_icon'>{langv?.strategy?.field3}</span>
                                                    {
                                                        n.score==5?
                                                        <svg className='def_like' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect width="20" height="20" rx="4" fill="#F2F2F7"/>
                                                            <path d="M5.74609 9.60652L10.5089 8.86719H13.2773V14.0518H5.74609V9.60652Z" fill="#AEAEB2"/>
                                                            <path d="M7.01899 9.58333C7.46676 9.58333 7.87065 9.33556 8.14732 8.98333C8.57809 8.43265 9.11956 7.97843 9.73676 7.65C10.1384 7.43667 10.4868 7.11889 10.6551 6.69722C10.7733 6.4018 10.834 6.08653 10.834 5.76833V5.41667C10.834 5.30616 10.8779 5.20018 10.956 5.12204C11.0342 5.0439 11.1401 5 11.2507 5C11.5822 5 11.9001 5.1317 12.1345 5.36612C12.369 5.60054 12.5007 5.91848 12.5007 6.25C12.5007 6.89 12.3562 7.49611 12.099 8.03778C11.9512 8.34778 12.1584 8.75 12.5018 8.75M12.5018 8.75H14.2384C14.8084 8.75 15.319 9.13556 15.3795 9.70278C15.4047 9.93722 15.4173 10.1752 15.4173 10.4167C15.4196 11.9369 14.9001 13.4118 13.9457 14.595C13.7301 14.8628 13.3973 15 13.054 15H10.8229C10.5542 15.0002 10.2873 14.957 10.0323 14.8722L8.30232 14.2944C8.04738 14.2096 7.78044 14.1665 7.51176 14.1667H6.61399M12.5018 8.75H11.2507H12.5018ZM6.61399 14.1667C6.66028 14.2804 6.71028 14.3919 6.76399 14.5011C6.87343 14.7233 6.72065 15 6.47343 15H5.96899C5.4751 15 5.01732 14.7122 4.87343 14.24C4.68101 13.6085 4.58346 12.9519 4.58399 12.2917C4.58399 11.4289 4.74788 10.605 5.04565 9.84833C5.21565 9.41833 5.64899 9.16667 6.11176 9.16667H6.69676C6.95899 9.16667 7.11065 9.47556 6.97454 9.7C6.50009 10.4811 6.24984 11.3778 6.25121 12.2917C6.25072 12.9342 6.37352 13.5708 6.61399 14.1667Z" fill="#AEAEB2"/>
                                                            <path d="M7.01899 9.58333C7.46676 9.58333 7.87065 9.33556 8.14732 8.98333C8.57809 8.43265 9.11956 7.97843 9.73676 7.65C10.1384 7.43667 10.4868 7.11889 10.6551 6.69722C10.7733 6.4018 10.834 6.08653 10.834 5.76833V5.41667C10.834 5.30616 10.8779 5.20018 10.956 5.12204C11.0342 5.0439 11.1401 5 11.2507 5C11.5822 5 11.9001 5.1317 12.1345 5.36612C12.369 5.60054 12.5007 5.91848 12.5007 6.25C12.5007 6.89 12.3562 7.49611 12.099 8.03778C11.9512 8.34778 12.1584 8.75 12.5018 8.75M12.5018 8.75H14.2384C14.8084 8.75 15.319 9.13556 15.3795 9.70278C15.4047 9.93722 15.4173 10.1752 15.4173 10.4167C15.4196 11.9369 14.9001 13.4118 13.9457 14.595C13.7301 14.8628 13.3973 15 13.054 15H10.8229C10.5542 15.0002 10.2873 14.957 10.0323 14.8722L8.30232 14.2944C8.04738 14.2096 7.78044 14.1665 7.51176 14.1667H6.61399M12.5018 8.75H11.2507M6.61399 14.1667C6.66028 14.2804 6.71028 14.3919 6.76399 14.5011C6.87343 14.7233 6.72065 15 6.47343 15H5.96899C5.4751 15 5.01732 14.7122 4.87343 14.24C4.68101 13.6085 4.58346 12.9519 4.58399 12.2917C4.58399 11.4289 4.74788 10.605 5.04565 9.84833C5.21565 9.41833 5.64899 9.16667 6.11176 9.16667H6.69676C6.95899 9.16667 7.11065 9.47556 6.97454 9.7C6.50009 10.4811 6.24984 11.3778 6.25121 12.2917C6.25072 12.9342 6.37352 13.5708 6.61399 14.1667Z" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        :
                                                        <svg className='def_like' width="20" height="20" onClick={()=>LikeMes(n.id)} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M7.02094 9.58333C7.46872 9.58333 7.87261 9.33556 8.14927 8.98333C8.58004 8.43265 9.12151 7.97843 9.73872 7.65C10.1404 7.43667 10.4887 7.11889 10.6571 6.69722C10.7753 6.4018 10.836 6.08653 10.8359 5.76833V5.41667C10.8359 5.30616 10.8798 5.20018 10.958 5.12204C11.0361 5.0439 11.1421 5 11.2526 5C11.5841 5 11.9021 5.1317 12.1365 5.36612C12.3709 5.60054 12.5026 5.91848 12.5026 6.25C12.5026 6.89 12.3582 7.49611 12.1009 8.03778C11.9532 8.34778 12.1604 8.75 12.5037 8.75M12.5037 8.75H14.2404C14.8104 8.75 15.3209 9.13556 15.3815 9.70278C15.4067 9.93722 15.4193 10.1752 15.4193 10.4167C15.4216 11.9369 14.9021 13.4118 13.9476 14.595C13.7321 14.8628 13.3993 15 13.0559 15H10.8248C10.5562 15.0002 10.2892 14.957 10.0343 14.8722L8.30427 14.2944C8.04933 14.2096 7.78239 14.1665 7.51372 14.1667H6.61594C6.66224 14.2804 6.71224 14.3919 6.76594 14.5011C6.87538 14.7233 6.72261 15 6.47538 15H5.97094C5.47705 15 5.01927 14.7122 4.87538 14.24C4.68296 13.6085 4.58542 12.9519 4.58594 12.2917C4.58594 11.4289 4.74983 10.605 5.04761 9.84833C5.21761 9.41833 5.65094 9.16667 6.11372 9.16667H6.69872C6.96094 9.16667 7.11261 9.47556 6.9765 9.7C6.50204 10.4811 6.25179 11.3778 6.25316 12.2917C6.25267 12.9342 6.37603 13.5708 6.6165 14.1667M12.5037 8.75H11.2526" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    }
                                                        <svg className='hov_like' onClick={()=>LikeMes(n.id)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect width="20" height="20" rx="4" fill="#E5E5EA"/>
                                                            <path d="M7.01899 9.58333C7.46676 9.58333 7.87065 9.33556 8.14732 8.98333C8.57809 8.43265 9.11956 7.97843 9.73676 7.65C10.1384 7.43667 10.4868 7.11889 10.6551 6.69722C10.7733 6.4018 10.834 6.08653 10.834 5.76833V5.41667C10.834 5.30616 10.8779 5.20018 10.956 5.12204C11.0342 5.0439 11.1401 5 11.2507 5C11.5822 5 11.9001 5.1317 12.1345 5.36612C12.369 5.60054 12.5007 5.91848 12.5007 6.25C12.5007 6.89 12.3562 7.49611 12.099 8.03778C11.9512 8.34778 12.1584 8.75 12.5018 8.75M12.5018 8.75H14.2384C14.8084 8.75 15.319 9.13556 15.3795 9.70278C15.4047 9.93722 15.4173 10.1752 15.4173 10.4167C15.4196 11.9369 14.9001 13.4118 13.9457 14.595C13.7301 14.8628 13.3973 15 13.054 15H10.8229C10.5542 15.0002 10.2873 14.957 10.0323 14.8722L8.30232 14.2944C8.04738 14.2096 7.78044 14.1665 7.51176 14.1667H6.61399C6.66028 14.2804 6.71028 14.3919 6.76399 14.5011C6.87343 14.7233 6.72065 15 6.47343 15H5.96899C5.4751 15 5.01732 14.7122 4.87343 14.24C4.68101 13.6085 4.58346 12.9519 4.58399 12.2917C4.58399 11.4289 4.74788 10.605 5.04565 9.84833C5.21565 9.41833 5.64899 9.16667 6.11176 9.16667H6.69676C6.95899 9.16667 7.11065 9.47556 6.97454 9.7C6.50009 10.4811 6.24984 11.3778 6.25121 12.2917C6.25072 12.9342 6.37408 13.5708 6.61454 14.1667M12.5018 8.75H11.2507" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    </div>
                                                    <div className='like'>
                                                        <span className='tolpipa_icon'>{langv?.strategy?.field4}</span>
                                                    {
                                                        n.score==0?
                                                        <svg className='def_like' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="20" y="20" width="20" height="20" rx="4" transform="rotate(180 20 20)" fill="#F2F2F7"/>
                                                            <path d="M5.74609 6.60652L10.8301 5.86719H13.7852V11.0518L13.0115 10.5447L9.10809 11.0518H5.74609V6.60652Z" fill="#AEAEB2"/>
                                                            <path d="M12.981 10.4167C12.5332 10.4167 12.1293 10.6644 11.8527 11.0167C11.4219 11.5673 10.8804 12.0216 10.2632 12.35C9.86157 12.5633 9.51324 12.8811 9.3449 13.3028C9.2267 13.5982 9.16599 13.9135 9.16601 14.2317V14.5833C9.16601 14.6938 9.12211 14.7998 9.04397 14.878C8.96583 14.9561 8.85985 15 8.74935 15C8.41783 15 8.09988 14.8683 7.86546 14.6339C7.63104 14.3995 7.49935 14.0815 7.49935 13.75C7.49935 13.11 7.64379 12.5039 7.90101 11.9622C8.04879 11.6522 7.84157 11.25 7.49823 11.25M7.49823 11.25H5.76157C5.19157 11.25 4.68101 10.8644 4.62046 10.2972C4.59527 10.0628 4.58268 9.82482 4.58268 9.58333C4.58038 8.06314 5.09987 6.58821 6.05435 5.405C6.2699 5.13722 6.60268 5 6.94601 5H9.17712C9.4458 4.99984 9.71274 5.04298 9.96768 5.12778L11.6977 5.70556C11.9526 5.79035 12.2196 5.8335 12.4882 5.83333H13.386M7.49823 11.25H8.74935H7.49823ZM13.386 5.83333C13.3397 5.71963 13.2897 5.60815 13.236 5.49889C13.1266 5.27667 13.2793 5 13.5266 5H14.031C14.5249 5 14.9827 5.28778 15.1266 5.76C15.319 6.39153 15.4165 7.04814 15.416 7.70833C15.416 8.57111 15.2521 9.395 14.9543 10.1517C14.7843 10.5817 14.351 10.8333 13.8882 10.8333H13.3032C13.041 10.8333 12.8893 10.5244 13.0255 10.3C13.4999 9.51889 13.7502 8.62224 13.7488 7.70833C13.7493 7.06579 13.6265 6.42918 13.386 5.83333Z" fill="#AEAEB2"/>
                                                            <path d="M12.981 10.4167C12.5332 10.4167 12.1293 10.6644 11.8527 11.0167C11.4219 11.5673 10.8804 12.0216 10.2632 12.35C9.86157 12.5633 9.51324 12.8811 9.3449 13.3028C9.2267 13.5982 9.16599 13.9135 9.16601 14.2317V14.5833C9.16601 14.6938 9.12211 14.7998 9.04397 14.878C8.96583 14.9561 8.85985 15 8.74935 15C8.41783 15 8.09988 14.8683 7.86546 14.6339C7.63104 14.3995 7.49935 14.0815 7.49935 13.75C7.49935 13.11 7.64379 12.5039 7.90101 11.9622C8.04879 11.6522 7.84157 11.25 7.49823 11.25M7.49823 11.25H5.76157C5.19157 11.25 4.68101 10.8644 4.62046 10.2972C4.59527 10.0628 4.58268 9.82482 4.58268 9.58333C4.58038 8.06314 5.09987 6.58821 6.05435 5.405C6.2699 5.13722 6.60268 5 6.94601 5H9.17712C9.4458 4.99984 9.71274 5.04298 9.96768 5.12778L11.6977 5.70556C11.9526 5.79035 12.2196 5.8335 12.4882 5.83333H13.386M7.49823 11.25H8.74935M13.386 5.83333C13.3397 5.71963 13.2897 5.60815 13.236 5.49889C13.1266 5.27667 13.2793 5 13.5266 5H14.031C14.5249 5 14.9827 5.28778 15.1266 5.76C15.319 6.39153 15.4165 7.04814 15.416 7.70833C15.416 8.57111 15.2521 9.395 14.9543 10.1517C14.7843 10.5817 14.351 10.8333 13.8882 10.8333H13.3032C13.041 10.8333 12.8893 10.5244 13.0255 10.3C13.4999 9.51889 13.7502 8.62224 13.7488 7.70833C13.7493 7.06579 13.6265 6.42918 13.386 5.83333Z" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        :
                                                        <svg className='def_like' width="20" height="20" onClick={()=>DisLikeMes(n.id)} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12.9791 10.4167C12.5313 10.4167 12.1274 10.6644 11.8507 11.0167C11.42 11.5673 10.8785 12.0216 10.2613 12.35C9.85962 12.5633 9.51128 12.8811 9.34295 13.3028C9.22475 13.5982 9.16403 13.9135 9.16406 14.2317V14.5833C9.16406 14.6938 9.12016 14.7998 9.04202 14.878C8.96388 14.9561 8.8579 15 8.74739 15C8.41587 15 8.09793 14.8683 7.86351 14.6339C7.62909 14.3995 7.49739 14.0815 7.49739 13.75C7.49739 13.11 7.64184 12.5039 7.89906 11.9622C8.04684 11.6522 7.83962 11.25 7.49628 11.25M7.49628 11.25H5.75962C5.18962 11.25 4.67906 10.8644 4.6185 10.2972C4.59332 10.0628 4.58073 9.82481 4.58073 9.58333C4.57843 8.06314 5.09792 6.58821 6.05239 5.405C6.26795 5.13722 6.60073 5 6.94406 5H9.17517C9.44384 4.99984 9.71079 5.04298 9.96573 5.12778L11.6957 5.70556C11.9507 5.79035 12.2176 5.8335 12.4863 5.83333H13.3841C13.3378 5.71963 13.2878 5.60815 13.2341 5.49889C13.1246 5.27667 13.2774 5 13.5246 5H14.0291C14.5229 5 14.9807 5.28778 15.1246 5.76C15.317 6.39153 15.4146 7.04814 15.4141 7.70833C15.4141 8.57111 15.2502 9.395 14.9524 10.1517C14.7824 10.5817 14.3491 10.8333 13.8863 10.8333H13.3013C13.0391 10.8333 12.8874 10.5244 13.0235 10.3C13.498 9.51889 13.7482 8.62224 13.7468 7.70833C13.7473 7.06579 13.624 6.42918 13.3835 5.83333M7.49628 11.25H8.74739" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                        }
                                                        <svg className='hov_like' onClick={()=>DisLikeMes(n.id)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="20" y="20" width="20" height="20" rx="4" transform="rotate(180 20 20)" fill="#E5E5EA"/>
                                                            <path d="M12.981 10.4167C12.5332 10.4167 12.1293 10.6644 11.8527 11.0167C11.4219 11.5673 10.8804 12.0216 10.2632 12.35C9.86157 12.5633 9.51324 12.8811 9.3449 13.3028C9.2267 13.5982 9.16599 13.9135 9.16601 14.2317V14.5833C9.16601 14.6938 9.12211 14.7998 9.04397 14.878C8.96583 14.9561 8.85985 15 8.74935 15C8.41783 15 8.09988 14.8683 7.86546 14.6339C7.63104 14.3995 7.49935 14.0815 7.49935 13.75C7.49935 13.11 7.64379 12.5039 7.90101 11.9622C8.04879 11.6522 7.84157 11.25 7.49823 11.25M7.49823 11.25H5.76157C5.19157 11.25 4.68101 10.8644 4.62046 10.2972C4.59527 10.0628 4.58268 9.82481 4.58268 9.58333C4.58038 8.06314 5.09987 6.58821 6.05435 5.405C6.2699 5.13722 6.60268 5 6.94601 5H9.17712C9.4458 4.99984 9.71274 5.04298 9.96768 5.12778L11.6977 5.70556C11.9526 5.79035 12.2196 5.8335 12.4882 5.83333H13.386C13.3397 5.71963 13.2897 5.60815 13.236 5.49889C13.1266 5.27667 13.2793 5 13.5266 5H14.031C14.5249 5 14.9827 5.28778 15.1266 5.76C15.319 6.39153 15.4165 7.04814 15.416 7.70833C15.416 8.57111 15.2521 9.395 14.9543 10.1517C14.7843 10.5817 14.351 10.8333 13.8882 10.8333H13.3032C13.041 10.8333 12.8893 10.5244 13.0255 10.3C13.4999 9.51889 13.7502 8.62224 13.7488 7.70833C13.7493 7.06579 13.6259 6.42918 13.3855 5.83333M7.49823 11.25H8.74935" stroke="#8E8E93" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>

                                                    </div>
                                                    
                                                    {/* <div className='like'>
                                                        <span className='tolpipa_icon'>Regenerate</span>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12.7653 14.1651C13.7411 13.5189 14.4592 12.5507 14.7944 11.4294C15.1296 10.308 15.0606 9.10462 14.5995 8.02891C14.1384 6.9532 13.3144 6.07341 12.2712 5.54292C11.228 5.01242 10.0316 4.86487 8.89075 5.12597M12.7653 14.1651V12.2214M12.7653 14.1651H14.7217M7.22476 5.84401C6.25233 6.49258 5.53797 7.46148 5.20591 8.5822C4.87386 9.70292 4.94511 10.9046 5.40729 11.9782C5.86946 13.0518 6.69331 13.9295 7.73558 14.4586C8.77785 14.9877 9.97261 15.1348 11.1121 14.8742M7.22476 5.84401V7.77878M7.22476 5.84401H5.28111" stroke="#8E8E93" stroke-width="0.583097" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                         {
                            load?
                            <div className='load_assistent'>
                                <Lottie animationData={Load} loop={true} />
                            </div>
                            :
                            <></>
                        }
                    </div>
                    <div className='assistant_messages_inputs'>
                        <div className='assistant_messages_tags'>
                            
                        </div>
                        <div className='assistant_messages_input'>
                            <div className='assistant_messages_skreppole'>
                                <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 13V7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7V15C13 16.0609 12.5786 17.0783 11.8284 17.8284C11.0783 18.5786 10.0609 19 9 19C7.93913 19 6.92172 18.5786 6.17157 17.8284C5.42143 17.0783 5 16.0609 5 15V7C5 6.46957 5.21071 5.96086 5.58579 5.58579C5.96086 5.21071 6.46957 5 7 5C7.53043 5 8.03914 5.21071 8.41421 5.58579C8.78929 5.96086 9 6.46957 9 7V15" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <textarea id='textarea' onKeyDown={handleKeyDown} onChange={(e)=>setInput0(e.target.value)} placeholder='Message AI-Assistant' value={input}></textarea>
                            </div>
                            {
                                load?
                                <div className={activbut?'assistant_messages_button active':'assistant_messages_button'} >
                                   
                                    <svg className='stop_hover_svg' width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="18" fill="#D1D1D6"/>
                                        <path d="M10.3092 17.0072C10.2555 17.0629 10.2134 17.1287 10.1851 17.2008C10.1569 17.2728 10.1431 17.3497 10.1446 17.4271C10.1477 17.5834 10.2126 17.732 10.3253 17.8404C10.4379 17.9488 10.589 18.0079 10.7452 18.0049C10.9015 18.0019 11.0502 17.9369 11.1585 17.8243L17.4128 11.3225V26.057C17.4128 26.2133 17.4749 26.3632 17.5854 26.4737C17.6959 26.5842 17.8458 26.6463 18.0021 26.6463C18.1584 26.6463 18.3083 26.5842 18.4188 26.4737C18.5293 26.3632 18.5914 26.2133 18.5914 26.057V11.3241L24.8441 17.8251C24.8977 17.8809 24.9619 17.9255 25.0328 17.9565C25.1037 17.9875 25.18 18.0042 25.2574 18.0057C25.3348 18.0072 25.4117 17.9935 25.4837 17.9652C25.5558 17.937 25.6216 17.8949 25.6773 17.8412C25.7331 17.7875 25.7778 17.7234 25.8088 17.6525C25.8397 17.5816 25.8565 17.5053 25.858 17.4279C25.8595 17.3505 25.8457 17.2736 25.8175 17.2016C25.7892 17.1295 25.7471 17.0637 25.6934 17.0079L18.5678 9.60023C18.4945 9.52407 18.4066 9.46348 18.3093 9.42209C18.212 9.38071 18.1074 9.35938 18.0017 9.35938C17.896 9.35938 17.7914 9.38071 17.6941 9.42209C17.5968 9.46348 17.5089 9.52407 17.4356 9.60023L10.3092 17.0072Z" fill="white"/>
                                    </svg>

                                </div>
                                :
                                <div className={activbut?'assistant_messages_button active':'assistant_messages_button'} onClick={activbut?()=>addmessages():undefined}>
                                   
                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="36" height="36" rx="18" fill="#D1D1D6"/>
                                        <path d="M10.3092 17.0072C10.2555 17.0629 10.2134 17.1287 10.1851 17.2008C10.1569 17.2728 10.1431 17.3497 10.1446 17.4271C10.1477 17.5834 10.2126 17.732 10.3253 17.8404C10.4379 17.9488 10.589 18.0079 10.7452 18.0049C10.9015 18.0019 11.0502 17.9369 11.1585 17.8243L17.4128 11.3225V26.057C17.4128 26.2133 17.4749 26.3632 17.5854 26.4737C17.6959 26.5842 17.8458 26.6463 18.0021 26.6463C18.1584 26.6463 18.3083 26.5842 18.4188 26.4737C18.5293 26.3632 18.5914 26.2133 18.5914 26.057V11.3241L24.8441 17.8251C24.8977 17.8809 24.9619 17.9255 25.0328 17.9565C25.1037 17.9875 25.18 18.0042 25.2574 18.0057C25.3348 18.0072 25.4117 17.9935 25.4837 17.9652C25.5558 17.937 25.6216 17.8949 25.6773 17.8412C25.7331 17.7875 25.7778 17.7234 25.8088 17.6525C25.8397 17.5816 25.8565 17.5053 25.858 17.4279C25.8595 17.3505 25.8457 17.2736 25.8175 17.2016C25.7892 17.1295 25.7471 17.0637 25.6934 17.0079L18.5678 9.60023C18.4945 9.52407 18.4066 9.46348 18.3093 9.42209C18.212 9.38071 18.1074 9.35938 18.0017 9.35938C17.896 9.35938 17.7914 9.38071 17.6941 9.42209C17.5968 9.46348 17.5089 9.52407 17.4356 9.60023L10.3092 17.0072Z" fill="white"/>
                                    </svg>
                                </div>
                            }
                           
                        </div>
                    </div>
                </div>
                <div id="controls"  className={shadow?'assistant_controls shadow':'assistant_controls'}>
                    <div id="resize"  onMouseEnter={()=>setShadow(true)} onMouseLeave={()=>setShadow(false)} ref={ref} className='butt_resize'>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="-0.5" y="-0.5" width="27" height="27" rx="13.5" transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 27 27)" fill="white" stroke="#DFE0E2"/>
                            <path d="M10.2816 11.3206C10.3188 11.3578 10.3484 11.4019 10.3685 11.4505C10.3887 11.4991 10.3991 11.5512 10.3991 11.6038C10.3991 11.6565 10.3887 11.7086 10.3685 11.7571C10.3484 11.8057 10.3188 11.8499 10.2816 11.887L8.96397 13.2038H12.7984C12.9045 13.2038 13.0062 13.246 13.0812 13.321C13.1562 13.396 13.1984 13.4978 13.1984 13.6038C13.1984 13.7099 13.1562 13.8117 13.0812 13.8867C13.0062 13.9617 12.9045 14.0038 12.7984 14.0038H8.96397L10.2816 15.3206C10.3567 15.3957 10.3989 15.4976 10.3989 15.6038C10.3989 15.7101 10.3567 15.8119 10.2816 15.887C10.2065 15.9621 10.1046 16.0043 9.99837 16.0043C9.89215 16.0043 9.79028 15.9621 9.71517 15.887L7.71517 13.887C7.67792 13.8499 7.64837 13.8057 7.6282 13.7571C7.60804 13.7086 7.59766 13.6565 7.59766 13.6038C7.59766 13.5512 7.60804 13.4991 7.6282 13.4505C7.64837 13.4019 7.67792 13.3578 7.71517 13.3206L9.71517 11.3206C9.75233 11.2834 9.79647 11.2538 9.84506 11.2337C9.89366 11.2135 9.94576 11.2031 9.99837 11.2031C10.051 11.2031 10.1031 11.2135 10.1517 11.2337C10.2003 11.2538 10.2444 11.2834 10.2816 11.3206ZM17.7152 11.3206C17.7523 11.2834 17.7965 11.2538 17.8451 11.2337C17.8937 11.2135 17.9458 11.2031 17.9984 11.2031C18.051 11.2031 18.1031 11.2135 18.1517 11.2337C18.2003 11.2538 18.2444 11.2834 18.2816 11.3206L20.2816 13.3206C20.3188 13.3578 20.3484 13.4019 20.3685 13.4505C20.3887 13.4991 20.3991 13.5512 20.3991 13.6038C20.3991 13.6565 20.3887 13.7086 20.3685 13.7571C20.3484 13.8057 20.3188 13.8499 20.2816 13.887L18.2816 15.887C18.2065 15.9621 18.1046 16.0043 17.9984 16.0043C17.8921 16.0043 17.7903 15.9621 17.7152 15.887C17.6401 15.8119 17.5979 15.7101 17.5979 15.6038C17.5979 15.4976 17.6401 15.3957 17.7152 15.3206L19.0328 14.0038H15.1984C15.0923 14.0038 14.9905 13.9617 14.9155 13.8867C14.8405 13.8117 14.7984 13.7099 14.7984 13.6038C14.7984 13.4978 14.8405 13.396 14.9155 13.321C14.9905 13.246 15.0923 13.2038 15.1984 13.2038H19.0328L17.7152 11.887C17.6779 11.8499 17.6484 11.8057 17.6282 11.7571C17.608 11.7086 17.5977 11.6565 17.5977 11.6038C17.5977 11.5512 17.608 11.4991 17.6282 11.4505C17.6484 11.4019 17.6779 11.3578 17.7152 11.3206Z" fill="black"/>
                        </svg>
                    </div>
                    <div className={load2?'strategy_body inactive':'strategy_body'} >
                        <div className='strategy_line_body'>
                            <div className='strategy_line_body_regal'>
                                <div className='body_regal_line1'>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g opacity="0.8">
                                            <path d="M7.79395 6.84766C9.23345 6.84766 10.4004 5.68071 10.4004 4.24121C10.4004 2.80171 9.23345 1.63477 7.79395 1.63477C6.35445 1.63477 5.1875 2.80171 5.1875 4.24121C5.1875 5.68071 6.35445 6.84766 7.79395 6.84766Z" stroke="#007AFF" stroke-width="0.8"/>
                                            <path d="M13.0508 11.734C13.0508 13.3533 13.0508 14.6663 7.83789 14.6663C2.625 14.6663 2.625 13.3533 2.625 11.734C2.625 10.1148 4.95907 8.80176 7.83789 8.80176C10.7167 8.80176 13.0508 10.1148 13.0508 11.734Z" stroke="#007AFF" stroke-width="0.8"/>
                                        </g>
                                    </svg>
                                    {langv?.strategy?.field5}
                                </div>
                                <div className='body_regal_line2'>
                                    {workspace?.statistics?.totalUsers||'0'}   
                                </div>
                            </div>
                            <div className='strategy_line_body_regal'>
                                <div className='body_regal_line1'>
                                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g opacity="0.8" clip-path="url(#clip0_2670_135222)">
                                        <path d="M8.26367 6.13086C9.83531 6.13086 11.1094 4.85679 11.1094 3.28516C11.1094 1.71352 9.83531 0.439453 8.26367 0.439453C6.69203 0.439453 5.41797 1.71352 5.41797 3.28516C5.41797 4.85679 6.69203 6.13086 8.26367 6.13086Z" stroke="#007AFF" stroke-width="0.8"/>
                                        <path d="M14 11.4661C14 13.234 14 14.6675 8.30859 14.6675C2.61719 14.6675 2.61719 13.234 2.61719 11.4661C2.61719 9.69817 5.16551 8.26465 8.30859 8.26465C11.4517 8.26465 14 9.69817 14 11.4661Z" stroke="#007AFF" stroke-width="0.8"/>
                                        <g clip-path="url(#clip1_2670_135222)">
                                        <path d="M15.2164 6.90039H11.0164C10.6298 6.90039 10.3164 7.21379 10.3164 7.60039V10.4004C10.3164 10.787 10.6298 11.1004 11.0164 11.1004H15.2164C15.603 11.1004 15.9164 10.787 15.9164 10.4004V7.60039C15.9164 7.21379 15.603 6.90039 15.2164 6.90039Z" fill="#F2F2F7" stroke="#007AFF" stroke-width="0.8"/>
                                        <path d="M10.3164 7.9502L12.8035 9.19375C12.9007 9.2423 13.0078 9.26757 13.1164 9.26757C13.225 9.26757 13.3321 9.2423 13.4293 9.19375L15.9164 7.9502" stroke="#007AFF" stroke-width="0.8"/>
                                        </g>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_2670_135222">
                                        <rect width="16" height="16" fill="white" transform="translate(0.417969)"/>
                                        </clipPath>
                                        <clipPath id="clip1_2670_135222">
                                        <rect width="7" height="7" fill="white" transform="translate(9.61719 5.5)"/>
                                        </clipPath>
                                        </defs>
                                    </svg>

                                    <p dangerouslySetInnerHTML={{__html:langv?.strategy?.field6}} style={{padding:"0px", margin:"0px"}}></p>
                                </div>
                                <div className='body_regal_line2'>
                                    {workspace?.statistics?.campaignUsers||'0'} <span>{workspace?.statistics?.coveragePercent||'0'} %</span>  
                                </div>
                            </div>
                            <div className='strategy_line_body_regal'>
                                <div className='body_regal_line1'>
                                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_2670_135237)">
                                        <path d="M15.5708 2.26165C15.4083 2.09913 15.2154 1.97021 15.003 1.88225C14.7907 1.79429 14.5631 1.74902 14.3333 1.74902C14.1035 1.74902 13.8759 1.79429 13.6635 1.88225C13.4512 1.97021 13.2583 2.09913 13.0958 2.26165C12.9333 2.42415 12.8043 2.61708 12.7164 2.82941C12.6284 3.04174 12.5832 3.26932 12.5832 3.49915C12.5832 3.72898 12.6284 3.95656 12.7164 4.16889C12.8043 4.38122 12.9333 4.57414 13.0958 4.73665C13.1567 4.79813 13.2223 4.85476 13.292 4.90602L11.4339 8.35665C11.1606 8.25718 10.8668 8.2272 10.579 8.26942C10.2912 8.31164 10.0184 8.42473 9.78516 8.59853L8.23391 7.04727C8.49886 6.69296 8.61977 6.25145 8.57233 5.81158C8.52488 5.37172 8.31259 4.96614 7.97818 4.67648C7.64377 4.38682 7.21205 4.23458 6.76992 4.25038C6.32778 4.26618 5.90804 4.44886 5.59516 4.76165C5.41715 4.9396 5.27962 5.15385 5.19195 5.38979C5.10429 5.62573 5.06855 5.87781 5.08718 6.12882C5.10581 6.37983 5.17836 6.62387 5.2999 6.84428C5.42143 7.0647 5.58908 7.2563 5.79141 7.40602L3.93266 10.8573C3.61947 10.7427 3.28006 10.72 2.95441 10.7919C2.62876 10.8638 2.33043 11.0272 2.09453 11.2629C1.84981 11.5076 1.68315 11.8195 1.61564 12.1589C1.54814 12.4984 1.5828 12.8503 1.71526 13.17C1.84772 13.4898 2.07202 13.7631 2.3598 13.9554C2.64758 14.1476 2.98592 14.2503 3.33203 14.2503C3.67814 14.2503 4.01648 14.1476 4.30426 13.9554C4.59204 13.7631 4.81635 13.4898 4.9488 13.17C5.08126 12.8503 5.11593 12.4984 5.04842 12.1589C4.98091 11.8195 4.81426 11.5076 4.56953 11.2629C4.50824 11.2018 4.44266 11.1452 4.37328 11.0935L6.23141 7.6429C6.50467 7.74282 6.79854 7.77304 7.08642 7.73081C7.3743 7.68857 7.64711 7.57523 7.88016 7.40102L9.43141 8.95228C9.224 9.22978 9.10362 9.56261 9.08554 9.90858C9.06745 10.2546 9.15246 10.5981 9.32981 10.8957C9.50715 11.1934 9.76884 11.4317 10.0817 11.5804C10.3946 11.7292 10.7446 11.7817 11.0874 11.7314C11.4302 11.681 11.7503 11.5301 12.0072 11.2977C12.2641 11.0652 12.4463 10.7618 12.5306 10.4257C12.6149 10.0897 12.5975 9.73621 12.4807 9.41003C12.3639 9.08386 12.153 8.79969 11.8745 8.59352L13.7327 5.14227C14.1069 5.27883 14.5165 5.28364 14.8938 5.15589C15.2711 5.02814 15.5935 4.77548 15.8078 4.43967C16.0221 4.10386 16.1154 3.70499 16.0723 3.30898C16.0292 2.91296 15.8523 2.5435 15.5708 2.26165ZM4.21578 13.3867C4.04098 13.5615 3.81825 13.6806 3.57577 13.7289C3.33328 13.7771 3.08193 13.7524 2.8535 13.6578C2.62507 13.5632 2.42982 13.403 2.29245 13.1974C2.15509 12.9918 2.08177 12.7501 2.08177 12.5029C2.08177 12.2557 2.15509 12.014 2.29245 11.8084C2.42982 11.6028 2.62507 11.4426 2.8535 11.348C3.08193 11.2534 3.33328 11.2287 3.57577 11.2769C3.81825 11.3252 4.04098 11.4443 4.21578 11.6192C4.44936 11.8535 4.58052 12.1708 4.58052 12.5016C4.58052 12.8325 4.44936 13.1498 4.21578 13.3841V13.3867ZM5.94828 6.88665C5.77352 6.71181 5.65452 6.48908 5.60633 6.24662C5.55814 6.00416 5.58292 5.75285 5.67754 5.52447C5.77217 5.2961 5.93238 5.1009 6.13793 4.96357C6.34348 4.82624 6.58514 4.75295 6.83234 4.75295C7.07955 4.75295 7.3212 4.82624 7.52675 4.96357C7.73231 5.1009 7.89252 5.2961 7.98715 5.52447C8.08177 5.75285 8.10655 6.00416 8.05836 6.24662C8.01017 6.48908 7.89117 6.71181 7.71641 6.88665C7.60012 7.00257 7.46214 7.09445 7.31034 7.15703C7.15854 7.21961 6.99589 7.25167 6.8317 7.25138C6.6675 7.25109 6.50497 7.21846 6.35339 7.15534C6.20182 7.09222 6.06416 6.99986 5.94828 6.88352V6.88665ZM11.717 10.8867C11.5422 11.0614 11.3195 11.1804 11.077 11.2286C10.8345 11.2768 10.5832 11.252 10.3549 11.1574C10.1265 11.0628 9.93128 10.9025 9.79395 10.697C9.65663 10.4914 9.58333 10.2498 9.58333 10.0026C9.58333 9.75538 9.65663 9.51373 9.79395 9.30818C9.93128 9.10263 10.1265 8.94241 10.3549 8.84779C10.5832 8.75316 10.8345 8.72838 11.077 8.77657C11.3195 8.82476 11.5422 8.94376 11.717 9.11852C11.9508 9.35286 12.0821 9.67034 12.0821 10.0013C12.0821 10.3323 11.9508 10.6498 11.717 10.8841V10.8867ZM15.217 4.38665C15.0422 4.56141 14.8195 4.68042 14.577 4.72861C14.3345 4.7768 14.0832 4.75201 13.8549 4.65739C13.6265 4.56276 13.4313 4.40255 13.294 4.197C13.1566 3.99145 13.0833 3.74979 13.0833 3.50259C13.0833 3.25538 13.1566 3.01373 13.294 2.80818C13.4313 2.60263 13.6265 2.44241 13.8549 2.34779C14.0832 2.25316 14.3345 2.22838 14.577 2.27657C14.8195 2.32476 15.0422 2.44376 15.217 2.61852C15.4506 2.85283 15.5818 3.17018 15.5818 3.50102C15.5818 3.83187 15.4506 4.14922 15.217 4.38352V4.38665Z" fill="#007AFF" stroke="#007AFF" stroke-width="0.3"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_2670_135237">
                                        <rect width="16" height="16" fill="white" transform="translate(0.832031)"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                    {langv?.strategy?.field7}
                                </div>
                                <div className='body_regal_line2'>
                                    {workspace?.statistics?.totalCampaigns||'0'}
                                </div>
                            </div>
                            <div className='strategy_line_body_regal'>
                                <div className='body_regal_line1'>
                                    <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.6823 1.32805C18.5815 1.22404 18.4617 1.14154 18.33 1.08526C18.1982 1.02897 18.0569 1 17.9143 1C17.7716 1 17.6304 1.02897 17.4986 1.08526C17.3668 1.14154 17.2471 1.22404 17.1462 1.32805C17.0453 1.43204 16.9653 1.5555 16.9107 1.69138C16.8561 1.82726 16.828 1.97289 16.828 2.11997C16.828 2.26704 16.8561 2.41268 16.9107 2.54856C16.9653 2.68444 17.0453 2.8079 17.1462 2.91189C17.184 2.95123 17.2247 2.98747 17.268 3.02028L16.1147 5.22846C15.9451 5.1648 15.7627 5.14562 15.5841 5.17264C15.4055 5.19966 15.2362 5.27203 15.0914 5.38324L14.1286 4.39054C14.293 4.16381 14.3681 3.88127 14.3386 3.59978C14.3092 3.31829 14.1774 3.05875 13.9699 2.87339C13.7623 2.68802 13.4944 2.59059 13.2199 2.60071C12.9455 2.61082 12.685 2.72772 12.4908 2.92789C12.3803 3.04176 12.295 3.17887 12.2406 3.32986C12.1861 3.48085 12.164 3.64216 12.1755 3.80279C12.1871 3.96342 12.2321 4.11959 12.3076 4.26064C12.383 4.40169 12.487 4.52431 12.6126 4.62012L11.459 6.8287C11.2646 6.75539 11.0539 6.74088 10.8518 6.78686C10.6497 6.83285 10.4645 6.93742 10.3181 7.08827C10.1662 7.2449 10.0628 7.44444 10.0209 7.66167C9.97896 7.87891 10.0005 8.10407 10.0827 8.3087C10.1649 8.51333 10.3041 8.68822 10.4827 8.81127C10.6614 8.93432 10.8713 9 11.0862 9C11.301 9 11.511 8.93432 11.6896 8.81127C11.8682 8.68822 12.0074 8.51333 12.0896 8.3087C12.1719 8.10407 12.1934 7.87891 12.1515 7.66167C12.1096 7.44444 12.0061 7.2449 11.8542 7.08827C11.8162 7.04919 11.7755 7.01297 11.7324 6.97988L12.8857 4.7717C13.0553 4.83565 13.2377 4.85498 13.4164 4.82796C13.5951 4.80093 13.7644 4.7284 13.909 4.61692L14.8718 5.60962C14.7431 5.78721 14.6684 6.00019 14.6572 6.2216C14.6459 6.443 14.6987 6.66286 14.8088 6.85332C14.9189 7.04377 15.0813 7.19626 15.2755 7.29146C15.4697 7.38666 15.6869 7.42028 15.8997 7.38807C16.1124 7.35586 16.3111 7.25926 16.4706 7.11052C16.63 6.96178 16.7431 6.76759 16.7954 6.55255C16.8477 6.3375 16.8369 6.11129 16.7645 5.90256C16.692 5.69383 16.561 5.51197 16.3882 5.38004L17.5415 3.17146C17.7737 3.25885 18.028 3.26193 18.2622 3.18017C18.4963 3.09842 18.6965 2.93674 18.8295 2.72184C18.9625 2.50694 19.0204 2.25169 18.9936 1.99827C18.9669 1.74485 18.8571 1.50842 18.6823 1.32805ZM11.6347 8.44734C11.5262 8.55923 11.3879 8.63544 11.2374 8.66632C11.0869 8.69721 10.9309 8.68138 10.7892 8.62085C10.6474 8.56031 10.5262 8.45778 10.4409 8.32623C10.3557 8.19468 10.3102 8.04001 10.3102 7.88179C10.3102 7.72357 10.3557 7.56891 10.4409 7.43736C10.5262 7.3058 10.6474 7.20328 10.7892 7.14274C10.9309 7.0822 11.0869 7.06638 11.2374 7.09726C11.3879 7.12815 11.5262 7.20435 11.6347 7.31625C11.7797 7.46619 11.8611 7.66927 11.8611 7.88099C11.8611 8.09271 11.7797 8.29579 11.6347 8.44574V8.44734ZM12.71 4.28775C12.6015 4.17587 12.5277 4.03334 12.4977 3.87818C12.4678 3.72301 12.4832 3.56219 12.5419 3.41605C12.6007 3.2699 12.7001 3.14499 12.8277 3.05711C12.9553 2.96922 13.1053 2.92232 13.2587 2.92232C13.4121 2.92232 13.5621 2.96922 13.6897 3.05711C13.8173 3.14499 13.9167 3.2699 13.9754 3.41605C14.0342 3.56219 14.0496 3.72301 14.0196 3.87818C13.9897 4.03334 13.9159 4.17587 13.8074 4.28775C13.7352 4.36193 13.6496 4.42073 13.5554 4.46078C13.4611 4.50083 13.3602 4.52134 13.2583 4.52116C13.1564 4.52097 13.0555 4.50009 12.9614 4.4597C12.8673 4.4193 12.7819 4.3602 12.71 4.28575V4.28775ZM16.2905 6.8475C16.1819 6.95933 16.0437 7.03549 15.8932 7.06633C15.7427 7.09716 15.5867 7.08131 15.445 7.02075C15.3032 6.9602 15.1821 6.85767 15.0969 6.72613C15.0116 6.59459 14.9661 6.43995 14.9661 6.28175C14.9661 6.12356 15.0116 5.96891 15.0969 5.83737C15.1821 5.70584 15.3032 5.60331 15.445 5.54275C15.5867 5.4822 15.7427 5.46634 15.8932 5.49718C16.0437 5.52802 16.1819 5.60417 16.2905 5.71601C16.4355 5.86597 16.517 6.06914 16.517 6.28095C16.517 6.49277 16.4355 6.69594 16.2905 6.8459V6.8475ZM18.4628 2.68791C18.3543 2.79975 18.216 2.8759 18.0655 2.90674C17.9151 2.93758 17.7591 2.92172 17.6173 2.86117C17.4756 2.80061 17.3544 2.69809 17.2692 2.56655C17.184 2.43501 17.1385 2.28036 17.1385 2.12217C17.1385 1.96397 17.184 1.80933 17.2692 1.67779C17.3544 1.54625 17.4756 1.44372 17.6173 1.38317C17.7591 1.32262 17.9151 1.30676 18.0655 1.3376C18.216 1.36843 18.3543 1.44459 18.4628 1.55643C18.6078 1.70637 18.6892 1.90945 18.6892 2.12117C18.6892 2.33289 18.6078 2.53597 18.4628 2.68591V2.68791Z" fill="#007AFF" stroke="#007AFF" stroke-width="0.3"/>
                                        <path d="M6.64648 7.13086C8.21812 7.13086 9.49219 5.85679 9.49219 4.28516C9.49219 2.71352 8.21812 1.43945 6.64648 1.43945C5.07485 1.43945 3.80078 2.71352 3.80078 4.28516C3.80078 5.85679 5.07485 7.13086 6.64648 7.13086Z" stroke="#007AFF" stroke-width="0.8"/>
                                        <path d="M12.3828 12.4661C12.3828 14.234 12.3828 15.6675 6.69141 15.6675C1 15.6675 1 14.234 1 12.4661C1 10.6982 3.54833 9.26465 6.69141 9.26465C9.83449 9.26465 12.3828 10.6982 12.3828 12.4661Z" stroke="#007AFF" stroke-width="0.8"/>
                                    </svg>
                                     {langv?.strategy?.field8}
                                </div>
                                <div className='body_regal_line2'>
                                     {workspace?.statistics?.avgCampaignsPerUser||'0'} 
                                </div>
                            </div>
                        </div>
                        <div className='strategy_line_body_drag'>
                           
                            <DndContext
                                sensors={sensors}
                                collisionDetection={closestCenter}
                                modifiers={[restrictToVerticalAxis]}
                                onDragEnd={handleDragEnd}
                                >
                                <SortableContext items={items.map(item => item.id)}  strategy={verticalListSortingStrategy} >
                                    {items.map(item => (
                                        <SortableItem id={item.id} title={item.title} reg1={item.reg1} reg2={item.reg2} reg3={item.reg3} description={item.description} open={item.open} new_st={item.new_st} value={item} company={item.company} onChange={handleChange} onClose={handleClose} onDelete={handleDelete} getDataStrategy={getDataStrategy} getDataWorkspace={getDataWorkspace} items={item.company} itemAll={item} />
                                    ))}
                                </SortableContext>
                            </DndContext>
                            
                        
                        </div>
                        <div className='strategy_line_body_drag'>
                            <div className='strategy_line_body_drag_butt' onClick={()=>AddNewLine()}>
                                {langv?.strategy?.button_8}
                                <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.7113 8.21053C16.89 8.51993 16.89 8.90112 16.7113 9.21053L13.1834 15.3211C13.0048 15.6305 12.6747 15.8211 12.3174 15.8211L5.26156 15.8211C4.90429 15.8211 4.57417 15.6305 4.39553 15.3211L0.867622 9.21053C0.688989 8.90112 0.688989 8.51993 0.867622 8.21053L4.39554 2.1C4.57417 1.7906 4.90429 1.6 5.26156 1.6L12.3174 1.6C12.6747 1.6 13.0048 1.7906 13.1834 2.1L16.7113 8.21053Z" fill="#F5C538" stroke="#F5C538" stroke-width="0.5"/>
                                    <path d="M9 5V12" stroke="#020203" stroke-width="0.5" stroke-linecap="round"/>
                                    <path d="M9 5V12" stroke="black" stroke-opacity="0.2" stroke-width="0.5" stroke-linecap="round"/>
                                    <path d="M9 5V12" stroke="black" stroke-opacity="0.2" stroke-width="0.5" stroke-linecap="round"/>
                                    <path d="M5.5 8.5H12.5" stroke="#020203" stroke-width="0.5" stroke-linecap="round"/>
                                    <path d="M5.5 8.5H12.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" stroke-linecap="round"/>
                                    <path d="M5.5 8.5H12.5" stroke="black" stroke-opacity="0.2" stroke-width="0.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    {
                        load2?
                        <div className='load_assistent_body_line'>
                            <div className='load_assistent_body'>
                                <Lottie animationData={Load} loop={true} />
                            </div>
                        </div>
                        :
                        <></>
                    }
                </div>
                
            </div>
            
        </>
    );
})

export default Strategy;
